// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Table, Container, Card, Pagination, Badge, Modal, Button, InputGroup, Form } from 'react-bootstrap';
// import { BsEye } from "react-icons/bs";

// const UserOrders = () => {
//     const [orders, setOrders] = useState([]);
//     const [filteredOrders, setFilteredOrders] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 10;
//     const [selectedOrder, setSelectedOrder] = useState(null);
//     const [showModal, setShowModal] = useState(false);
//     const [searchTerm, setSearchTerm] = useState("");
//     const [filterType, setFilterType] = useState("All");

//     useEffect(() => {
//         fetchOrders();
//     }, []);

//     const fetchOrders = async () => {
//         try {
//             const response = await axios.get('http://localhost:4001/all-user-orders');
//             setOrders(response.data);
//             setFilteredOrders(response.data);  // Set initial filtered orders
//         } catch (error) {
//             console.error('Error fetching orders:', error);
//         }
//     };

//     const handleViewDetails = (order) => {
//         setSelectedOrder(order);
//         setShowModal(true);
//     };

//     const handleCloseModal = () => {
//         setShowModal(false);
//         setSelectedOrder(null);
//     };

//     // Search Function
//     useEffect(() => {
//         let results = orders;

//         if (searchTerm) {
//             results = orders.filter(order =>
//                 order.User?.Id?.toString().includes(searchTerm) ||
//                 order.User?.mobile?.toString().includes(searchTerm)
//             );
//         }

//         if (filterType !== "All") {
//             results = results.filter(order => order.Service?.services_name === filterType);
//         }

//         setFilteredOrders(results);
//         setCurrentPage(1);
//     }, [searchTerm, filterType, orders]);

//     // Pagination Logic
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentItems = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     // Dynamically Render Order Details
//     const renderOrderDetails = () => {
//         if (!selectedOrder) return null;

//         let details = {};
//         let type = "";

//         if ('Fan_in_un' in selectedOrder) {
//             type = "Electrician";
//             details = {
//                 "Fan Installation Units": selectedOrder.Fan_in_un,
//                 "Light Installation Units": selectedOrder.Light_in_un,
//                 "Fan Repair": selectedOrder.Fan_repair,
//                 "Light Repair": selectedOrder.Light_repair,
//                 "Switch Board Repair": selectedOrder.Switch_repair,
//                 "MCB Servicing": selectedOrder.MCB_service,
//                 "MDB Servicing": selectedOrder.MDB_service,
//             };
//         } else if ('bed' in selectedOrder) {
//             type = "Home Cleaning";
//             details = {
//                 "Bed Cleaning": selectedOrder.bed,
//                 "Bathroom Cleaning": selectedOrder.bath,
//                 "Drawing/Dining Cleaning": selectedOrder.dra_din,
//                 "Kitchen Cleaning": selectedOrder.kitchen,
//                 "Cloth Washing": selectedOrder.cloth,
//                 "Dish Washing": selectedOrder.dish,
//             };
//         } else {
//             type = "Plumber";
//             details = {
//                 "Toilet Installation": selectedOrder.Toilet_in,
//                 "Faucet Installation": selectedOrder.Faucet_in,
//                 "Sink Installation": selectedOrder.Sink_in,
//                 "Dishwasher Installation": selectedOrder.Dishwasher_in,
//                 "Leak Repair": selectedOrder.Leak_repair,
//                 "Faucet Repair": selectedOrder.Faucet_repair,
//                 "Toilet Repair": selectedOrder.Toilet_repair,
//                 "Shower Repair": selectedOrder.Shower_repair,
//                 "Drain Cleaning": selectedOrder.Drain_cleaning,
//             };
//         }

//         return (
//             <div>
//                 <h5 className="text-primary">{type} Order Details</h5>
//                 <ul className="list-group">
//                     {Object.entries(details).map(([key, value]) => (
//                         <li key={key} className="list-group-item d-flex justify-content-between">
//                             <span>{key}</span>
//                             <strong>{value}</strong>
//                         </li>
//                     ))}
//                 </ul>
//             </div>
//         );
//     };

//     return (
//         <Container>
//             <Card>
//                 <Card.Body>
//                     <Card.Title className="mb-3" style={{ fontSize: '26px', fontWeight: '400' }}>
//                         All User Orders
//                     </Card.Title>

//                     {/* Search Bar */}
//                     <InputGroup className="mb-3">
//                         <Form.Control
//                             type="text"
//                             placeholder="Search by User ID or Mobile Number"
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                         />
//                     </InputGroup>

//                     {/* Filter Buttons */}
//                     <div className="mb-3">
//                         {["All", "Electrician", "Home Cleaning", "Plumber"].map(type => (
//                             <Button
//                                 key={type}
//                                 variant={filterType === type ? "primary" : "outline-primary"}
//                                 className="me-2"
//                                 onClick={() => setFilterType(type)}
//                             >
//                                 {type}
//                             </Button>
//                         ))}
//                     </div>

//                     <Table striped bordered hover responsive>
//                         <thead>
//                             <tr>
//                                 <th>#</th>
//                                 <th>User ID</th>
//                                 <th>User</th>
//                                 <th>Mobile</th>
//                                 <th>Service</th>
//                                 <th>Status</th>
//                                 <th>Price</th>
//                                 <th>Date</th>
//                                 <th>Time</th>
//                                 <th>Action</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {currentItems.map((order, index) => (
//                                 <tr key={order.Id}>
//                                     <td>{index + 1 + indexOfFirstItem}</td>
//                                     <td>{order.User?.Id}</td>
//                                     <td>{order.User?.FirstName} {order.User?.LastName}</td>
//                                     <td>{order.User?.mobile}</td>
//                                     <td>{order.Service?.services_name}</td>
//                                     <td>
//                                         <Badge bg={order.status === 'pending' ? 'warning' : order.status.toLowerCase() === 'cancelled' ? 'danger' : 'success'}>
//                                             {order.status}
//                                         </Badge>
//                                     </td>
//                                     <td>${order.price}</td>
//                                     <td>{order.date}</td>
//                                     <td>{order.time}</td>
//                                     <td>
//                                         <Button variant="outline-primary" size="sm" onClick={() => handleViewDetails(order)}>
//                                             <BsEye size={20} />
//                                         </Button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </Table>

//                     {/* Pagination */}
//                     <Pagination>
//                         <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                         <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                         {[...Array(totalPages)].map((_, index) => (
//                             <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => handlePageChange(index + 1)}>
//                                 {index + 1}
//                             </Pagination.Item>
//                         ))}
//                         <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                         <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                     </Pagination>
//                 </Card.Body>
//             </Card>

//             {/* Modal for Viewing Order Details */}
//             <Modal show={showModal} onHide={handleCloseModal} centered>
//                 <Modal.Header closeButton>
//                     <Modal.Title>Order Details</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     {renderOrderDetails()}
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button variant="secondary" onClick={handleCloseModal}>
//                         Close
//                     </Button>
//                 </Modal.Footer>
//             </Modal>
//         </Container>
//     );
// };

// export default UserOrders;

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Table, Container, Card, Pagination, Badge, Modal, Button, InputGroup, Form, Row, Col } from 'react-bootstrap';
// import { BsEye } from "react-icons/bs";

// const UserOrders = () => {
//     const [orders, setOrders] = useState([]);
//     const [filteredOrders, setFilteredOrders] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 10;
//     const [selectedOrder, setSelectedOrder] = useState(null);
//     const [showModal, setShowModal] = useState(false);
//     const [searchTerm, setSearchTerm] = useState("");
//     const [filterType, setFilterType] = useState("All");
//     const [filterStatus, setFilterStatus] = useState("All");

//     useEffect(() => {
//         fetchOrders();
//     }, []);

//     const fetchOrders = async () => {
//         try {
//             const response = await axios.get('http://localhost:4001/all-user-orders');
//             setOrders(response.data);
//             setFilteredOrders(response.data);  // Set initial filtered orders
//         } catch (error) {
//             console.error('Error fetching orders:', error);
//         }
//     };

//     const handleViewDetails = (order) => {
//         setSelectedOrder(order);
//         setShowModal(true);
//     };

//     const handleCloseModal = () => {
//         setShowModal(false);
//         setSelectedOrder(null);
//     };

//     // Search & Filter Function
//     useEffect(() => {
//         let results = orders;

//         if (searchTerm) {
//             results = results.filter(order =>
//                 order.User?.Id?.toString().includes(searchTerm) ||
//                 order.User?.mobile?.toString().includes(searchTerm)
//             );
//         }

//         if (filterType !== "All") {
//             results = results.filter(order => order.Service?.services_name === filterType);
//         }

//         if (filterStatus !== "All") {
//             results = results.filter(order =>
//                 order.status && order.status.toLowerCase() === filterStatus.toLowerCase()
//             );
//         }

//         setFilteredOrders(results);
//         setCurrentPage(1);
//     }, [searchTerm, filterType, filterStatus, orders]);

//     // Pagination Logic
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentItems = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     // Dynamically Render Order Details
//     const renderOrderDetails = () => {
//         if (!selectedOrder) return null;

//         let details = {};
//         // let type = "";
//         const type = selectedOrder.service_name;

//         // if ('Fan_in_un' in selectedOrder) {
//         //     type = "Electrician";
//         //     details = {
//         //         "Fan Installation Units": selectedOrder.Fan_in_un,
//         //         "Light Installation Units": selectedOrder.Light_in_un,
//         //         "Fan Repair": selectedOrder.Fan_repair,
//         //         "Light Repair": selectedOrder.Light_repair,
//         //         "Switch Board Repair": selectedOrder.Switch_repair,
//         //         "MCB Servicing": selectedOrder.MCB_service,
//         //         "MDB Servicing": selectedOrder.MDB_service,
//         //     };
//         // } else if ('bed' in selectedOrder) {
//         //     type = "Home Cleaning";
//         //     details = {
//         //         "Bed Cleaning": selectedOrder.bed,
//         //         "Bathroom Cleaning": selectedOrder.bath,
//         //         "Drawing/Dining Cleaning": selectedOrder.dra_din,
//         //         "Kitchen Cleaning": selectedOrder.kitchen,
//         //         "Cloth Washing": selectedOrder.cloth,
//         //         "Dish Washing": selectedOrder.dish,
//         //     };
//         // } else {
//         //     type = "Plumber";
//         //     details = {
//         //         "Toilet Installation": selectedOrder.Toilet_in,
//         //         "Faucet Installation": selectedOrder.Faucet_in,
//         //         "Sink Installation": selectedOrder.Sink_in,
//         //         "Dishwasher Installation": selectedOrder.Dishwasher_in,
//         //         "Leak Repair": selectedOrder.Leak_repair,
//         //         "Faucet Repair": selectedOrder.Faucet_repair,
//         //         "Toilet Repair": selectedOrder.Toilet_repair,
//         //         "Shower Repair": selectedOrder.Shower_repair,
//         //         "Drain Cleaning": selectedOrder.Drain_cleaning,
//         //     };
//         // }

//         if (type === "Electrician") {
//           details = {
//             "Fan Installation Units": selectedOrder.Fan_in_un,
//             "Light Installation Units": selectedOrder.Light_in_un,
//             "Fan Repair": selectedOrder.Fan_repair,
//             "Light Repair": selectedOrder.Light_repair,
//             "Switch Board Repair": selectedOrder.Switch_repair,
//             "MCB Servicing": selectedOrder.MCB_service,
//             "MDB Servicing": selectedOrder.MDB_service,
//             "Regulator Install/Uninstall": selectedOrder.Fan_regulator_in_un,
//             "Regulator Repair":            selectedOrder.Fan_regulator_repair,
//             "Socket Install/Uninstall":    selectedOrder.Socket_in_un,
//             "Socket Repair":               selectedOrder.Socket_repair,
//             "Circuit Breaker Repair":      selectedOrder.Circuit_breaker_repair,
//             "New Wiring Point":            selectedOrder.New_wiring_point,
//             "Full Wiring":      selectedOrder.Full_wiring ? "Yes" : "No",
//             "Electrical Checkup":          selectedOrder.Electrical_checkup ? "Yes" : "No",
//           };
//         } else if (type === "Home Cleaning") {
//           details = {
//             "Bed Cleaning": selectedOrder.bed,
//             "Bathroom Cleaning": selectedOrder.bath,
//             "Drawing/Dining Cleaning": selectedOrder.dra_din,
//             "Kitchen Cleaning": selectedOrder.kitchen,
//             "Balcony Cleaning": selectedOrder.balcony,
//             "Window & Grill Cleaning": selectedOrder.window_grill,
//             "Furniture Cleaning": selectedOrder.furniture_cleaning,
//             "Cloth Washing": selectedOrder.cloth,
//             "Dish Washing": selectedOrder.dish,
//           };
//         } else if (type === "Plumber") {
//           details = {
//             "Toilet Installation": selectedOrder.Toilet_in,
//             "Faucet Installation": selectedOrder.Faucet_in,
//             "Sink Installation": selectedOrder.Sink_in,
//             "Dishwasher Installation": selectedOrder.Dishwasher_in,
//             "Leak Repair": selectedOrder.Leak_repair,
//             "Faucet Repair": selectedOrder.Faucet_repair,
//             "Toilet Repair": selectedOrder.Toilet_repair,
//             "Shower Repair": selectedOrder.Shower_repair,
//             "Drain Cleaning": selectedOrder.Drain_cleaning,
//             "Pipe Cleaning":   selectedOrder.pipe_cleaning,
//             "Tank Cleaning":   selectedOrder.tank_cleaning,
//             "Issue Checkup":   selectedOrder.issue_checkup ? "Yes" : "No",
//           };
//         }

//         return (
//           <div>
//             <h5 className="text-primary">{type} Order Details</h5>
//             <ul className="list-group">
//               {Object.entries(details).map(([key, value]) => (
//                 <li
//                   key={key}
//                   className="list-group-item d-flex justify-content-between"
//                 >
//                   <span>{key}</span>
//                   <strong>{value}</strong>
//                 </li>
//               ))}

//               {selectedOrder.status.toLowerCase() === "cancelled" &&
//                 selectedOrder.cancellation_feedback && (
//                   <div className="mt-4 p-3 bg-light rounded text-center border">
//                     <h4 className="mb-2">Cancellation Details</h4>
//                     <hr />
//                     <strong className="mb-0">
//                       {selectedOrder.cancellation_feedback}
//                     </strong>
//                   </div>
//                 )}
//             </ul>
//           </div>
//         );
//     };

//     return (
//         <Container fluid >
//             <Card>
//                 <Card.Body>
//                     <Card.Title className="mb-3" style={{ fontSize: '26px', fontWeight: '400' }}>
//                         All User Orders
//                     </Card.Title>

//                     <Row className="mb-3">
//                         {/* Search Bar */}
//                         <Col md={8}>
//                             <InputGroup>
//                                 <Form.Control
//                                     type="text"
//                                     placeholder="Search by User ID or Mobile Number"
//                                     value={searchTerm}
//                                     onChange={(e) => setSearchTerm(e.target.value)}
//                                 />
//                             </InputGroup>
//                         </Col>
//                         {/* Status filter */}
//                         <Col md={4}>
//                             <Form.Group controlId="statusFilter">
//                                 <Form.Select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
//                                     <option value="All">All Statuses</option>
//                                     <option value="pending">Pending</option>
//                                     <option value="Accepted">Accepted</option>
//                                     <option value="In-Progress">In-Progress</option>
//                                     <option value="Cancelled">Cancelled</option>
//                                     <option value="Cancelled by Servitor">Cancelled by Servitor</option>
//                                     <option value="Completed">Completed</option>
//                                 </Form.Select>
//                             </Form.Group>
//                         </Col>
//                     </Row>

//                     {/* Service Filter Buttons */}
//                     <div className="mb-3">
//                         {["All", "Electrician", "Home Cleaning", "Plumber"].map(type => (
//                             <Button
//                                 key={type}
//                                 variant={filterType === type ? "primary" : "outline-primary"}
//                                 className="me-2 mb-2"
//                                 onClick={() => setFilterType(type)}
//                             >
//                                 {type}
//                             </Button>
//                         ))}
//                     </div>

//                     <Table striped bordered hover responsive>
//                         <thead>
//                             <tr>
//                                 <th>#</th>
//                                 <th>Order number</th>
//                                 <th>User ID</th>
//                                 <th>User</th>
//                                 <th>Mobile</th>
//                                 <th>Service</th>
//                                 <th>Status</th>
//                                 <th>Price</th>
//                                 <th>Date</th>
//                                 <th>Time</th>
//                                 <th>Action</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {currentItems.map((order, index) => (
//                                 <tr key={order.Id}>
//                                     <td>{index + 1 + indexOfFirstItem}</td>
//                                     <td>{order.order_number}</td>
//                                     <td>{order.User?.Id}</td>
//                                     <td>{order.User?.FirstName} {order.User?.LastName}</td>
//                                     <td>{order.User?.mobile}</td>
//                                     <td>{order.Service?.services_name}</td>
//                                     <td>
//                                         <Badge
//                                           bg={
//                                             order.status.toLowerCase() === 'pending' || order.status.toLowerCase() === 'deadline-timeout'
//                                               ? 'warning'
//                                               : order.status.toLowerCase() === 'cancelled' || order.status.toLowerCase() === 'cancelled by servitor'
//                                               ? 'danger'
//                                               : order.status.toLowerCase() === 'in-progress'
//                                               ? 'primary'
//                                               : order.status.toLowerCase() === 'confirmed'
//                                               ? 'info'
//                                               : 'success'
//                                           }
//                                         >
//                                             {order.status}
//                                         </Badge>
//                                     </td>
//                                     <td>{order.price}Tk</td>
//                                     <td>{order.date}</td>
//                                     <td>{order.time}</td>
//                                     <td>
//                                         <Button variant="outline-primary" size="sm" onClick={() => handleViewDetails(order)}>
//                                             <BsEye size={20} />
//                                         </Button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </Table>

//                     {/* Pagination */}
//                     <Pagination>
//                         <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                         <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                         {[...Array(totalPages)].map((_, index) => (
//                             <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => handlePageChange(index + 1)}>
//                                 {index + 1}
//                             </Pagination.Item>
//                         ))}
//                         <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                         <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                     </Pagination>
//                 </Card.Body>
//             </Card>

//             {/* Modal for Viewing Order Details */}
//             <Modal show={showModal} onHide={handleCloseModal} centered>
//                 <Modal.Header closeButton>
//                     <Modal.Title>Order Details</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     {renderOrderDetails()}
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button variant="secondary" onClick={handleCloseModal}>
//                         Close
//                     </Button>
//                 </Modal.Footer>
//             </Modal>
//         </Container>
//     );
// };

// export default UserOrders;

// import React, { useEffect, useState, useRef, useMemo } from "react";
// import axios from "axios";
// import {
//   Table,
//   Container,
//   Card,
//   Pagination,
//   Badge,
//   Button,
//   InputGroup,
//   Form,
//   Row,
//   Col,
// } from "react-bootstrap";
// import { BsEye } from "react-icons/bs";
// import {
//   FaTimes,
//   FaBolt,
//   FaUser,
//   FaCheckCircle,
//   FaDollarSign,
//   FaCalendar,
//   FaPlusCircle,
//   FaWrench,
//   FaCogs,
//   FaStar,
//   FaUserCircle,
//   FaPhone,
//   FaIdBadge,
//   FaMapMarkerAlt,
//   FaClock,
//   FaPrint,
//   FaDownload,
//   FaCheck,
//   FaEdit,
//   FaTrash,
//   FaBroom,
//   FaFire,
//   FaSnowflake,
//   FaFilter,
//   FaUserGraduate,
// } from "react-icons/fa";
// import "./UserOrderStyle.css";
// import { Spinner } from "react-bootstrap";
// import { formatDate } from "../../dateTimefrontpart";
// import { URL } from "../../../config";

// /* ===========================
//    HELPERS — date/time utils
//    =========================== */
// const pad2 = (n) => String(n).padStart(2, "0");

// // normalize date to YYYY-MM-DD
// function toDateISO(raw) {
//   if (!raw) {
//     const d = new Date();
//     return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
//   }
//   const s = String(raw).trim();
//   if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
//   const d = new Date(s);
//   if (isNaN(d.getTime())) {
//     const n = new Date();
//     return `${n.getFullYear()}-${pad2(n.getMonth() + 1)}-${pad2(n.getDate())}`;
//   }
//   return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
// }

// const todayISO = () => {
//   const d = new Date();
//   return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
// };

// // "HH:mm" -> minutes since midnight
// function minutesFromHHmm(hhmm) {
//   if (!hhmm) return null;
//   const m = String(hhmm).match(/^(\d{1,2}):(\d{2})$/);
//   if (!m) return null;
//   return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
// }

// // "h:mm AM/PM" -> minutes since midnight
// function minutesFromAMPM(s) {
//   const m = String(s).match(/^\s*(\d{1,2})[:.](\d{2})\s*([AP]M)\s*$/i);
//   if (!m) return null;
//   let h = parseInt(m[1], 10);
//   const min = parseInt(m[2], 10);
//   const ampm = m[3].toUpperCase();
//   if (ampm === "PM" && h < 12) h += 12;
//   if (ampm === "AM" && h === 12) h = 0;
//   return h * 60 + min;
// }

// // accepts "HH:mm" or "h:mm AM/PM" and returns minutes
// function minutesFromAnyTime(t) {
//   if (!t) return null;
//   const s = String(t).trim();
//   const hhmm = s.match(/^\d{1,2}:\d{2}$/);
//   if (hhmm) return minutesFromHHmm(s);
//   return minutesFromAMPM(s);
// }

// function toAMPMFromMinutes(mins) {
//   if (mins == null) return "";
//   let h = Math.floor(mins / 60);
//   const m = mins % 60;
//   const am = h < 12;
//   let displayHour = h % 12;
//   if (displayHour === 0) displayHour = 12;
//   return `${displayHour}:${pad2(m)} ${am ? "AM" : "PM"}`;
// }

// // for display everywhere
// function formatTimeDisplay(raw) {
//   const mins = minutesFromAnyTime(raw);
//   if (mins == null) return String(raw ?? "");
//   return toAMPMFromMinutes(mins);
// }

// // For deadline
// function formatDeadlineTime(raw) {
//   if (!raw) return "-";
//   const d = new Date(raw);
//   if (isNaN(d.getTime())) return String(raw);
//   return toAMPMFromMinutes(d.getHours() * 60 + d.getMinutes());
// }

// // compute min date/time (cannot go earlier than current schedule; also not earlier than today)
// function getMinLimitsForOrder(order, { ignoreExisting = false } = {}) {
//   const schedDateISO = toDateISO(order?.date);
//   const schedTimeMins = minutesFromAnyTime(order?.time); // handles "16:30" or "4:30 PM"
//   const now = new Date();
//   const nowDateISO = todayISO();
//   const nowMins = now.getHours() * 60 + now.getMinutes();

//   // min date is the later of today vs scheduled date
//   const minDateISO = ignoreExisting
//     ? nowDateISO
//     : schedDateISO >= nowDateISO
//     ? schedDateISO
//     : nowDateISO;

//   // min time depends on chosen date
//   function computeMinTimeMins(newDateISO) {
//     if (!newDateISO) return null;
//     if (!ignoreExisting) {
//       if (newDateISO === schedDateISO && schedDateISO >= nowDateISO) {
//         return schedTimeMins ?? null;
//       }
//     }
//     if (newDateISO === nowDateISO) {
//       return nowMins;
//     }
//     return null;
//   }
//   return { minDateISO, computeMinTimeMins };
// }

// // generate 30-min slots (7:00–21:00), excluding slots < min on chosen day, and past slots today
// function generateSlotsAMPM(dateISO, minDateISO, minTimeMinsForThisDate) {
//   const slots = [];
//   if (!dateISO) return slots;

//   const startHour = 7;
//   const endHour = 21; // inclusive hour for last slot start (21:00)

//   const now = new Date();
//   const today = todayISO();
//   const isToday = dateISO === today;

//   const baseMin = minTimeMinsForThisDate ?? null; // boundary for this selected date

//   for (let h = startHour; h <= endHour; h++) {
//     for (let m = 0; m < 60; m += 30) {
//       const mins = h * 60 + m;

//       // block if selected date is before minDate
//       if (dateISO < minDateISO) continue;

//       // block if it's today and slot <= now
//       if (isToday) {
//         const nowMins = now.getHours() * 60 + now.getMinutes();
//         if (mins <= nowMins) continue;
//       }

//       // block if earlier than minimum boundary (previous schedule)
//       if (baseMin != null && mins < baseMin) continue;

//       slots.push(toAMPMFromMinutes(mins));
//     }
//   }
//   return slots;
// }
// /* =========================== */

// const UserOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [filteredOrders, setFilteredOrders] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterType, setFilterType] = useState("All");
//   const [filterStatus, setFilterStatus] = useState("All");
//   const modalRef = useRef(null);

//   const editModalRef = useRef(null);

//   // Edit schedule modal state
//   const [showEdit, setShowEdit] = useState(false);
//   const [editOrder, setEditOrder] = useState(null);
//   const [saving, setSaving] = useState(false);
//   const [editForm, setEditForm] = useState({
//     newDate: "", // YYYY-MM-DD
//     newSlot: "", // "h:mm AM/PM"
//     keepServitor: false,
//     reason: "",
//     reorder: false,
//   });

//   const itemsPerPage = 10;

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   const fetchOrders = async () => {
//     try {
//       const response = await axios.get(`${URL}/all-user-orders`);
//       setOrders(response.data);
//       setFilteredOrders(response.data);
//     } catch (error) {
//       console.error("Error fetching orders:", error);
//     }
//   };

//   const handleViewDetails = (order) => {
//     setSelectedOrder(order);
//     setShowModal(true);
//     document.body.style.overflow = "hidden";
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedOrder(null);
//     document.body.style.overflow = "auto";
//   };

//   const handleCloseEdit = () => {
//     setShowEdit(false);
//     setEditOrder(null);
//     setSaving(false);
//     document.body.style.overflow = "auto";
//   };

//   const forceKeepStatuses = [
//     "Accepted",
//     "In-Progress",
//     "Cancelled by Servitor",
//   ];

//   const handleEditOrder = (order) => {
//     if (!order) return;
//     const st = String(order.status || "").toLowerCase();
//     if (st === "in-progress") {
//       alert("In-Progress orders cannot be rescheduled.");
//       return;
//     }
//     if (st === "completed") {
//       alert("Completed orders cannot be rescheduled.");
//       return;
//     }

//     setEditOrder(order);

//     const dISO = toDateISO(order.date);
//     const timeAMPM = formatTimeDisplay(order.time);
//     const forceKeep = forceKeepStatuses.includes(order.status);

//     setEditForm({
//       newDate: dISO,
//       newSlot: timeAMPM,
//       keepServitor: forceKeep,
//       reason: "",
//       reorder: false,
//     });

//     setShowEdit(true);
//     document.body.style.overflow = "hidden";
//   };

//   const handleDeleteOrder = (order) => {
//     console.log("Deleting order:", order);
//     // Implement delete functionality here
//   };

//   useEffect(() => {
//     const node = modalRef.current;
//     const handleBackdropClick = (e) => {
//       if (node && e.target === node) {
//         handleCloseModal();
//       }
//     };

//     const handleEscapeKey = (e) => {
//       if (e.key === "Escape") {
//         handleCloseModal();
//       }
//     };

//     if (node) {
//       node.addEventListener("click", handleBackdropClick);
//     }
//     document.addEventListener("keydown", handleEscapeKey);

//     return () => {
//       if (node) {
//         node.removeEventListener("click", handleBackdropClick);
//       }
//       document.removeEventListener("keydown", handleEscapeKey);
//     };
//   }, []);

//   // Edit modal close on backdrop + Esc
//   useEffect(() => {
//     const node = editModalRef.current;
//     const handleBackdropClick = (e) => {
//       if (node && e.target === node) handleCloseEdit();
//     };
//     const handleEscapeKey = (e) => {
//       if (e.key === "Escape") handleCloseEdit();
//     };
//     if (node) node.addEventListener("click", handleBackdropClick);
//     document.addEventListener("keydown", handleEscapeKey);
//     return () => {
//       if (node) node.removeEventListener("click", handleBackdropClick);
//       document.removeEventListener("keydown", handleEscapeKey);
//     };
//   }, []);

//   // recompute slot list when date/order changes
//   const slotData = useMemo(() => {
//     if (!editOrder)
//       return { slots: [], minDateISO: todayISO(), minTimeInfo: null };
//     const { minDateISO, computeMinTimeMins } = getMinLimitsForOrder(editOrder, {
//       ignoreExisting: !!editForm.reorder,
//     });
//     const minMins = computeMinTimeMins(editForm.newDate);
//     const slots = generateSlotsAMPM(editForm.newDate, minDateISO, minMins);

//     // ensure selected slot is valid; if not, pick first available
//     let selected = editForm.newSlot;
//     const found = slots.includes(selected);
//     if (!found && slots.length > 0) {
//       selected = slots[0];
//       setEditForm((f) => ({ ...f, newSlot: selected }));
//     }
//     return {
//       slots,
//       minDateISO,
//       minTimeInfo:
//         minMins != null
//           ? `Earliest allowed this day: ${toAMPMFromMinutes(minMins)}`
//           : null,
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [editOrder, editForm.newDate]);

//   const submitEdit = async () => {
//     if (!editOrder) return;

//     const st = String(editOrder.status || "").toLowerCase();
//     if (st === "in-progress" || st === "completed") {
//       alert("This order cannot be rescheduled.");
//       return;
//     }

//     if (!editForm.newDate || !editForm.newSlot) {
//       alert("Please select both a date and a time slot.");
//       return;
//     }

//     const serviceType = editOrder?.Service?.services_name || "";
//     const url = `${URL}/admin/orders/${encodeURIComponent(
//       serviceType
//     )}/${editOrder.Id}/reschedule`;

//     // Validate date/time against min limits
//     const { minDateISO, computeMinTimeMins } = getMinLimitsForOrder(editOrder, {
//       ignoreExisting: !!editForm.reorder,
//     });
//     if (editForm.newDate < minDateISO) {
//       alert("New date cannot be earlier than the current schedule/today.");
//       return;
//     }
//     const slotMins = minutesFromAMPM(editForm.newSlot);
//     const minMins = computeMinTimeMins(editForm.newDate);
//     if (minMins != null && slotMins < minMins) {
//       alert(`New time cannot be earlier than ${toAMPMFromMinutes(minMins)}.`);
//       return;
//     }

//     const payload = {
//       keepServitor: editForm.keepServitor,
//       reason: editForm.reason?.trim() || undefined,
//       reorder: !!editForm.reorder,
//       newDate: editForm.newDate,
//       newTime: editForm.newSlot, // backend accepts AM/PM
//     };

//     try {
//       setSaving(true);
//       const resp = await axios.post(url, payload);
//       const updated = resp?.data?.order;
//       if (!updated) {
//         await fetchOrders();
//       } else {
//         setOrders((prev) =>
//           prev.map((o) =>
//             o.Id === updated.Id &&
//             (o.Service?.services_name || "") ===
//               (updated.Service?.services_name || "")
//               ? updated
//               : o
//           )
//         );
//         if (
//           selectedOrder &&
//           selectedOrder.Id === updated.Id &&
//           (selectedOrder.Service?.services_name || "") ===
//             (updated.Service?.services_name || "")
//         ) {
//           setSelectedOrder(updated);
//         }
//       }
//       alert(resp?.data?.message || "Order rescheduled");
//       handleCloseEdit();
//     } catch (err) {
//       console.error("Reschedule failed:", err);
//       const msg =
//         err?.response?.data?.message ||
//         err?.response?.data?.error ||
//         "Failed to reschedule";
//       alert(msg);
//     } finally {
//       setSaving(false);
//     }
//   };

//   useEffect(() => {
//     let results = orders;

//     if (searchTerm) {
//       const term = searchTerm.toLowerCase();
//       results = results.filter(
//         (order) =>
//           order.User?.Id?.toString().includes(term) ||
//           order.User?.mobile?.toString().includes(term) ||
//           order.order_number?.toLowerCase().includes(term)
//       );
//     }

//     if (filterType !== "All") {
//       results = results.filter(
//         (order) => order.Service?.services_name === filterType
//       );
//     }

//     if (filterStatus !== "All") {
//       results = results.filter(
//         (order) =>
//           order.status &&
//           order.status.toLowerCase() === filterStatus.toLowerCase()
//       );
//     }

//     setFilteredOrders(results);
//     setCurrentPage(1);
//   }, [searchTerm, filterType, filterStatus, orders]);

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const handlePrintReceipt = () => {
//     console.log("Printing order receipt...");
//   };

//   const handleDownloadInvoice = () => {
//     console.log("Downloading invoice...");
//   };

//   // build an ordered list of timeline steps
//   const buildTimeline = (order) => {
//     const steps = [];

//     steps.push({
//       key: "placed",
//       label: "Order Placed",
//       time: order.created_at,
//       dotClass: "completed",
//     });

//     if (order.accepted_at) {
//       steps.push({
//         key: "accepted",
//         label: "Order Accepted",
//         time: order.accepted_at,
//         dotClass:
//           order.status === "Accepted" ||
//           order.status === "In-Progress" ||
//           order.status === "Completed"
//             ? "completed"
//             : "inactive",
//       });
//     }

//     if (order.in_progress_at) {
//       steps.push({
//         key: "in_progress",
//         label: "Service In Progress",
//         time: order.in_progress_at,
//         dotClass:
//           order.status === "In-Progress" || order.status === "Completed"
//             ? "in-progress"
//             : "inactive",
//       });
//     }

//     if (order.completed_at) {
//       steps.push({
//         key: "completed",
//         label: "Order Completed",
//         time: order.completed_at,
//         dotClass: "arrived",
//       });
//     }

//     if (order.status.toLowerCase().includes("cancel")) {
//       steps.push({
//         key: "cancelled",
//         label: `Order ${order.status}`,
//         time: order.updated_at,
//         dotClass: "cancelled",
//       });
//     }

//     return steps;
//   };

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];

//     pages.push(1);

//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);

//     if (current <= siblings + 2) {
//       end = Math.min(total - 1, maxButtons - 1);
//     }
//     if (current >= total - (siblings + 1)) {
//       start = Math.max(2, total - (maxButtons - 2));
//     }

//     if (start > 2) {
//       pages.push("start-ellipsis");
//     }

//     for (let i = start; i <= end; i++) {
//       pages.push(i);
//     }

//     if (end < total - 1) {
//       pages.push("end-ellipsis");
//     }

//     if (total > 1) {
//       pages.push(total);
//     }

//     return pages;
//   };

//   const renderOrderDetails = () => {
//     if (!selectedOrder) return null;

//     let details = {};
//     const type = selectedOrder.service_name;
//     let icon = <FaBolt />;

//     if (type === "Electrician") {
//       details = {
//         Installation: {
//           "Fan Installation Units": selectedOrder.Fan_in_un,
//           "Light Installation Units": selectedOrder.Light_in_un,
//           "Doorbell Setup Units": selectedOrder.Doorbell_setup,
//           "Exhaust Fan Setup Units": selectedOrder.Exhaust_fan_setup,
//           "Regulator Install/Uninstall": selectedOrder.Fan_regulator_in_un,
//           "Socket Install/Uninstall": selectedOrder.Socket_in_un,
//         },
//         Repair: {
//           "Fan Repair": selectedOrder.Fan_repair,
//           "Light Repair": selectedOrder.Light_repair,
//           "Exhaust Fan Repair": selectedOrder.Exhaust_fan_repair,
//           "Switch Board Repair": selectedOrder.Switch_repair,
//           "Socket Repair": selectedOrder.Socket_repair,
//           "Circuit Breaker Repair": selectedOrder.Circuit_breaker_repair,
//         },
//         Maintenance: {
//           "MCB Servicing": selectedOrder.MCB_service,
//           "MDB Servicing": selectedOrder.MDB_service,
//         },
//         Additional: {
//           "New Wiring Point": selectedOrder.New_wiring_point,
//           "Drill Wall holes": selectedOrder.Drill_wall_holes,
//           "Coil Repair": selectedOrder.Coil_repair,
//           // "Full Wiring": selectedOrder.Full_wiring ? "Yes" : "No",
//           "Electrical Checkup": selectedOrder.Electrical_checkup ? "Yes" : "No",
//         },
//       };
//       icon = <FaBolt />;
//     } else if (type === "Home Cleaning") {
//       details = {
//         "Room Cleaning": {
//           "Bed Cleaning": selectedOrder.bed,
//           "Bathroom Cleaning": selectedOrder.bath,
//           "Drawing/Dining Cleaning": selectedOrder.dra_din,
//           "Balcony Cleaning": selectedOrder.balcony,
//           "Kitchen Cleaning": selectedOrder.kitchen,
//           "Satirs & Railing Cleaning": selectedOrder.stairs_and_railing,
//         },
//         "Additional Cleaning": {
//           "Window & Grill Cleaning": selectedOrder.window_grill,
//           "Furniture Cleaning": selectedOrder.furniture_cleaning,
//           "Cloth Washing": selectedOrder.cloth,
//           "Dish Washing": selectedOrder.dish,
//           "Carpet Cleaning": selectedOrder.carpet_cleaning,
//         },
//       };
//       icon = <FaBroom />;
//     } else if (type === "Plumber") {
//       details = {
//         Installation: {
//           "Toilet Installation": selectedOrder.Toilet_in,
//           "Faucet Installation": selectedOrder.Faucet_in,
//           "Sink Installation": selectedOrder.Sink_in,
//           "Dishwasher Installation": selectedOrder.Dishwasher_in,
//           "Geyser Installation": selectedOrder.geyser_setup,
//         },
//         Repair: {
//           "Leak Repair": selectedOrder.Leak_repair,
//           "Faucet Repair": selectedOrder.Faucet_repair,
//           "Toilet Repair": selectedOrder.Toilet_repair,
//           "Shower Repair": selectedOrder.Shower_repair,
//           "Geyser Repair": selectedOrder.geyser_repair,
//         },
//         Maintenance: {
//           "Drain Cleaning": selectedOrder.Drain_cleaning,
//           "Pipe Cleaning": selectedOrder.pipe_cleaning,
//           "Tank Cleaning": selectedOrder.tank_cleaning,
//           "Issue Checkup": selectedOrder.issue_checkup ? "Yes" : "No",
//         },
//       };
//       icon = <FaCogs />;
//     } else if (type === "Gas Chula") {
//       details = {
//         Installation: {
//           "Cylinder Type": selectedOrder.chulaCylinderType,
//           "New Chula Setup": selectedOrder.NewchulaSetup,
//           "Chula Setup": selectedOrder.chulaSetup,
//           "Burner Setup": selectedOrder.burnerSetup,
//         },
//         Maintenance: {
//           "Burner Cleaning": selectedOrder.burnerCleaning,
//           "Nozzle Replacement": selectedOrder.nozzleReplacement,
//           "Check Issues": selectedOrder.checkIssues ? "Yes" : "No",
//         },
//       };
//       icon = <FaFire />;
//     } else if (type === "AC Service") {
//       details = {
//         Specifications: {
//           "AC Type": selectedOrder.acType || "-",
//           "AC Ton": selectedOrder.acTon || "-",
//         },
//         Installation: {
//           "New Setup": selectedOrder.new_setup,
//           Installation: selectedOrder.installation,
//           Uninstallation: selectedOrder.uninstallation,
//         },
//         Maintenance: {
//           "Gas Refill": selectedOrder.gas_refill,
//           Cleaning: selectedOrder.cleaning,
//           "Issue Checkup": selectedOrder.issue_checkup ? "Yes" : "No",
//         },
//       };
//       icon = <FaSnowflake />;
//     } else if (type === "Filter") {
//       details = {
//         Specifications: {
//           "Filter Type": selectedOrder.filter_type || "-",
//         },
//         Additional: {
//           "Issue Checkup": selectedOrder.check_up ? "Yes" : "No",
//         },
//         Installation: {
//           "New Filter Setup": selectedOrder.new_filter_setup,
//           "Filter Installation": selectedOrder.installation_filter,
//           "Filter Uninstallation": selectedOrder.uninstallation_filter,
//         },
//         Maintenance: {
//           "Kit Replacement": selectedOrder.kit_replacement,
//           "Pipe Leak / Replace": selectedOrder.pipe_leak_or_replace,
//           "Full Servicing": selectedOrder.full_servicing,
//         },
//       };
//       icon = <FaFilter />;
//     } else if (type === "Tutor Service") {
//       const clean = (v) =>
//         v !== undefined &&
//         v !== null &&
//         String(v).trim() !== "" &&
//         String(v).trim().toLowerCase() !== "any";

//       const core = {};
//       if (clean(selectedOrder.subject)) core["Subject"] = selectedOrder.subject;
//       if (clean(selectedOrder.classLevel))
//         core["Class/Level"] = selectedOrder.classLevel;
//       if (clean(selectedOrder.medium)) core["Medium"] = selectedOrder.medium;

//       const schedule = {};
//       if (clean(selectedOrder.daysPerWeek))
//         schedule["Days per Week"] = `${selectedOrder.daysPerWeek}`;
//       if (clean(selectedOrder.hoursPerDay))
//         schedule["Hours per Day"] = `${selectedOrder.hoursPerDay}`;
//       if (clean(selectedOrder.salary))
//         schedule["Salary"] = `৳${selectedOrder.salary}`;

//       const prefs = {};
//       if (clean(selectedOrder.preferredTutorGender))
//         prefs["Preferred Tutor Gender"] = selectedOrder.preferredTutorGender;
//       if (clean(selectedOrder.priorityInstitution))
//         prefs["Priority Institution"] = selectedOrder.priorityInstitution;

//       details = {};
//       if (Object.keys(core).length) details["Tutoring"] = core;
//       if (Object.keys(schedule).length) details["Schedule & Budget"] = schedule;
//       if (Object.keys(prefs).length) details["Preferences"] = prefs;

//       icon = <FaUserGraduate />;
//     }

//     return (
//       <div className="adminUserorder-modal">
//         {/* Modal Header */}
//         <div className="adminUserorder-modal-header">
//           <button
//             className="adminUserorder-modal-close"
//             onClick={handleCloseModal}
//           >
//             <FaTimes size={20} />
//           </button>
//           <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//             <div className="adminUserorder-service-icon">{icon}</div>
//             <div>
//               <h2 className="adminUserorder-modal-title">Order Details</h2>
//               <p className="adminUserorder-modal-subtitle">
//                 Order #{selectedOrder.order_number} • {type} Service
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Modal Body */}
//         <div className="adminUserorder-modal-body">
//           {/* Summary Cards */}
//           <div className="adminUserorder-summary-cards">
//             <div className="adminUserorder-summary-card adminUserorder-status-card">
//               <div>
//                 <p className="adminUserorder-detail-text">Status</p>
//                 <span
//                   className={`adminUserorder-badge-${selectedOrder.status
//                     .toLowerCase()
//                     .replace(" ", "-")}`}
//                 >
//                   {selectedOrder.status}
//                 </span>
//               </div>
//               <FaCheckCircle size={24} style={{ color: "#22c55e" }} />
//             </div>

//             <div className="adminUserorder-summary-card adminUserorder-price-card">
//               <div>
//                 <p className="adminUserorder-detail-text">Total Amount</p>
//                 <p className="adminUserorder-price-value">
//                   ৳{selectedOrder.price}
//                 </p>
//               </div>
//               <FaDollarSign size={24} style={{ color: "#2563eb" }} />
//             </div>

//             <div className="adminUserorder-summary-card adminUserorder-date-card">
//               <div>
//                 <p className="adminUserorder-detail-text">Service Date</p>
//                 <p className="adminUserorder-date-value">
//                   {selectedOrder.date}
//                 </p>
//                 <p className="adminUserorder-time-value">
//                   {selectedOrder.time}
//                 </p>
//               </div>
//               <FaCalendar size={24} style={{ color: "#7c3aed" }} />
//             </div>
//           </div>

//           {/* Customer Information */}
//           <div className="adminUserorder-detail-card">
//             <h3 className="adminUserorder-detail-title">
//               <FaUser
//                 style={{ marginRight: "8px", color: "var(--primary-color)" }}
//               />
//               Customer Information
//             </h3>
//             <div className="adminUserorder-customer-grid">
//               <div>
//                 <div className="adminUserorder-customer-info">
//                   <FaUserCircle className="adminUserorder-customer-icon" />
//                   <div>
//                     <p className="adminUserorder-detail-text">Customer Name</p>
//                     <p className="adminUserorder-detail-value">
//                       {selectedOrder.User?.FirstName}{" "}
//                       {selectedOrder.User?.LastName}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminUserorder-customer-info">
//                   <FaPhone className="adminUserorder-customer-icon" />
//                   <div>
//                     <p className="adminUserorder-detail-text">Mobile Number</p>
//                     <p className="adminUserorder-detail-value">
//                       {selectedOrder.User?.mobile}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="adminUserorder-customer-info">
//                   <FaIdBadge className="adminUserorder-customer-icon" />
//                   <div>
//                     <p className="adminUserorder-detail-text">User ID</p>
//                     <p className="adminUserorder-detail-value">
//                       {selectedOrder.User?.Id}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminUserorder-customer-info">
//                   <FaMapMarkerAlt className="adminUserorder-customer-icon" />
//                   <div>
//                     <p className="adminUserorder-detail-text">
//                       Service Location
//                     </p>
//                     <p className="adminUserorder-detail-value">
//                       {/* {selectedOrder.User?.city}, {selectedOrder.User?.Address} */}

//                       {/* This is for user location what set in profile */}
//                       {/* {[selectedOrder.User?.city, selectedOrder.User?.area, selectedOrder.User?.Address]
//                         .filter(Boolean)
//                         .join("- ")} */}

//                       {/* This is for Service location where user placed order */}
//                       {[selectedOrder.City, selectedOrder.Area, selectedOrder.Address]
//                         .filter(Boolean)
//                         .join(" - ")
//                       }

//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {["Accepted", "Completed", "Cancelled by Servitor"].includes(
//             selectedOrder.status
//           ) && (
//             <div className="adminUserorder-detail-card">
//               <h3 className="adminUserorder-detail-title">
//                 <FaUser
//                   style={{ marginRight: "8px", color: "var(--primary-color)" }}
//                 />
//                 Servitor Information
//               </h3>
//               <div className="adminUserorder-customer-grid">
//                 <div>
//                   <div className="adminUserorder-customer-info">
//                     <FaUserCircle className="adminUserorder-customer-icon" />
//                     <div>
//                       <p className="adminUserorder-detail-text">
//                         Servitor Name
//                       </p>
//                       <p className="adminUserorder-detail-value">
//                         {selectedOrder.Servitor?.FirstName}{" "}
//                         {selectedOrder.Servitor?.LastName}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminUserorder-customer-info">
//                     <FaPhone className="adminUserorder-customer-icon" />
//                     <div>
//                       <p className="adminUserorder-detail-text">
//                         Mobile Number
//                       </p>
//                       <p className="adminUserorder-detail-value">
//                         {selectedOrder.Servitor?.mobile}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//                 <div>
//                   <div className="adminUserorder-customer-info">
//                     <FaIdBadge className="adminUserorder-customer-icon" />
//                     <div>
//                       <p className="adminUserorder-detail-text">NID</p>
//                       <p className="adminUserorder-detail-value">
//                         {selectedOrder.Servitor?.NID}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminUserorder-customer-info">
//                     <FaMapMarkerAlt className="adminUserorder-customer-icon" />
//                     <div>
//                       <p className="adminUserorder-detail-text">Address</p>
//                       <p className="adminUserorder-detail-value">
//                         {/* {selectedOrder.Servitor?.city},{" "}
//                         {selectedOrder.Servitor?.Address} */}
//                         {[selectedOrder.Servitor?.city, selectedOrder.Servitor?.area, selectedOrder.Servitor?.Address]
//                         .filter(Boolean)
//                         .join(" - ")}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Service Details */}
//           <div className="adminUserorder-detail-card">
//             <h3 className="adminUserorder-detail-title">
//               {type} Service Details
//             </h3>
//             <div className="adminUserorder-service-grid">
//               {Object.entries(details).map(([category, items]) => (
//                 <div key={category} className="adminUserorder-service-category">
//                   <h4 className="adminUserorder-category-title">
//                     {category === "Installation" && (
//                       <FaPlusCircle
//                         style={{ marginRight: "8px", color: "#22c55e" }}
//                       />
//                     )}
//                     {category === "Repair" && (
//                       <FaWrench
//                         style={{ marginRight: "8px", color: "#f59e0b" }}
//                       />
//                     )}
//                     {category === "Maintenance" && (
//                       <FaCogs
//                         style={{ marginRight: "8px", color: "#3b82f6" }}
//                       />
//                     )}
//                     {category === "Additional" && (
//                       <FaStar
//                         style={{ marginRight: "8px", color: "#7c3aed" }}
//                       />
//                     )}
//                     {category === "Room Cleaning" && (
//                       <FaBroom
//                         style={{ marginRight: "8px", color: "#10b981" }}
//                       />
//                     )}
//                     {category === "Additional Cleaning" && (
//                       <FaStar
//                         style={{ marginRight: "8px", color: "#7c3aed" }}
//                       />
//                     )}
//                     {category === "Specifications" && (
//                       <FaSnowflake
//                         style={{ marginRight: "8px", color: "#7c3aed" }}
//                       />
//                     )}
//                     {category === "Tutoring" && (
//                       <FaUserGraduate
//                         style={{ marginRight: "8px", color: "#2563eb" }}
//                       />
//                     )}
//                     {category === "Schedule & Budget" && (
//                       <FaCalendar
//                         style={{ marginRight: "8px", color: "#7c3aed" }}
//                       />
//                     )}
//                     {category === "Preferences" && (
//                       <FaStar
//                         style={{ marginRight: "8px", color: "#f59e0b" }}
//                       />
//                     )}
//                     {category}
//                   </h4>
//                   <div
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       gap: "8px",
//                     }}
//                   >
//                     {Object.entries(items).map(([key, value]) => (
//                       <div
//                         key={key}
//                         className={`adminUserorder-service-item ${
//                           value === 0 || value === "No" ? "inactive" : ""
//                         }`}
//                       >
//                         <span
//                           className={`adminUserorder-service-name ${
//                             value === 0 || value === "No" ? "inactive" : ""
//                           }`}
//                         >
//                           {key}
//                         </span>
//                         <span
//                           className={`adminUserorder-service-value${
//                             value === 0 || value === "No" ? "-inactive" : ""
//                           }`}
//                         >
//                           {value}
//                         </span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="adminUserorder-detail-card">
//             <h3 className="adminUserorder-detail-title">
//               <FaClock
//                 style={{ marginRight: "8px", color: "var(--primary-color)" }}
//               />
//               Order Timeline
//             </h3>
//             <div
//               style={{ display: "flex", flexDirection: "column", gap: "16px" }}
//             >
//               {buildTimeline(selectedOrder).map((step) => (
//                 <div key={step.key} className="adminUserorder-timeline-item">
//                   {step.key === "cancelled" ? (
//                     <FaTimes
//                       size={16}
//                       className="adminUserorder-timeline-cancel-icon"
//                     />
//                   ) : (
//                     <div
//                       className={`adminUserorder-timeline-dot ${step.dotClass}`}
//                     ></div>
//                   )}
//                   <div className="adminUserorder-timeline-content">
//                     <h4>{step.label}</h4>
//                     <p>{new Date(step.time).toLocaleString()}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {selectedOrder.customerFeedback != null && (
//             <div className="adminUserorder-detail-card">
//               <h3 className="adminUserorder-detail-title">
//                 <FaStar style={{ marginRight: 8, color: "#f59e0b" }} />
//                 Customer Feedback
//               </h3>
//               <p className="adminUserorder-detail-value">
//                 {selectedOrder.customerFeedback}
//               </p>
//             </div>
//           )}

//           {/* Cancellation Details (if applicable) */}
//           {/* {selectedOrder.status.toLowerCase() === "cancelled" &&
//             selectedOrder.cancellation_feedback && (
//               <div className="adminUserorder-detail-card">
//                 <h3 className="adminUserorder-detail-title">
//                   <FaTimes style={{ marginRight: "8px", color: "#ef4444" }} />
//                   Cancellation Details
//                 </h3>
//                 <p className="adminUserorder-detail-value">
//                   {selectedOrder.cancellation_feedback}
//                 </p>
//               </div>
//             )} */}

//           {(() => {
//             const fb = selectedOrder?.cancellation_feedback;
//             const hasFeedback =
//               typeof fb === "string" ? fb.trim().length > 0 : !!fb;

//             return (
//               hasFeedback && (
//                 <div className="adminUserorder-detail-card">
//                   <h3 className="adminUserorder-detail-title">
//                     <FaTimes style={{ marginRight: "8px", color: "#ef4444" }} />
//                     Cancellation Feedback
//                   </h3>
//                   <p className="adminUserorder-detail-value">{fb}</p>
//                 </div>
//               )
//             );
//           })()}
//         </div>

//         {/* Modal Footer */}
//         <div className="adminUserorder-modal-footer">
//           <div className="adminUserorder-footer-buttons">
//             <button
//               className="adminUserorder-footer-btn adminUserorder-footer-btn-print"
//               onClick={handlePrintReceipt}
//             >
//               <FaPrint />
//               Print Receipt
//             </button>
//             <button
//               className="adminUserorder-footer-btn adminUserorder-footer-btn-download"
//               onClick={handleDownloadInvoice}
//             >
//               <FaDownload />
//               Download Invoice
//             </button>
//             <button
//               className="adminUserorder-footer-btn adminUserorder-footer-btn-close"
//               onClick={handleCloseModal}
//             >
//               <FaCheck />
//               Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <Container fluid className="adminUserorder-container">
//       <Card className="adminUserorder-card">
//         <Card.Body>
//           <Card.Header className="adminUserorder-header">
//             <h4 className="adminUserorder-title">All User Orders</h4>
//           </Card.Header>

//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by Order Number, User ID or Mobile Number"
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="adminUserorder-search"
//                 />
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Group controlId="statusFilter">
//                 <Form.Select
//                   value={filterStatus}
//                   onChange={(e) => setFilterStatus(e.target.value)}
//                   className="adminUserorder-filter-select"
//                 >
//                   <option value="All">All Statuses</option>
//                   <option value="pending">Pending</option>
//                   <option value="Accepted">Accepted</option>
//                   <option value="In-Progress">In-Progress</option>
//                   <option value="Cancelled">Cancelled</option>
//                   <option value="Cancelled by Servitor">
//                     Cancelled by Servitor
//                   </option>
//                   <option value="Completed">Completed</option>
//                   <option value="Deadline-Timeout">Deadline-Timeout</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="adminUserorder-filter-container">
//             {[
//               "All",
//               "Electrician",
//               "Home Cleaning",
//               "Plumber",
//               "Gas Chula",
//               "AC Service",
//               "Filter",
//               "Tutor Service",
//             ].map((type) => (
//               <Button
//                 key={type}
//                 variant={filterType === type ? "primary" : "outline-primary"}
//                 className="adminUserorder-filter-btn"
//                 onClick={() => setFilterType(type)}
//               >
//                 {type}
//               </Button>
//             ))}
//           </div>

//           <Table
//             striped
//             bordered
//             hover
//             responsive
//             className="adminUserorder-table"
//           >
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Order number</th>
//                 <th>User ID</th>
//                 <th>Mobile</th>
//                 <th>Service</th>
//                 <th>Status</th>
//                 <th>Price</th>
//                 <th>Date</th>
//                 <th>Time</th>
//                 <th>Deadline</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {currentItems.map((order, index) => {
//                 const statusLC = String(order.status || "").toLowerCase();
//                 const editDisabled =
//                   statusLC === "in-progress" || statusLC === "completed";
//                 return (
//                   <tr key={order.Id}>
//                     <td>{index + 1 + indexOfFirstItem}</td>
//                     <td>{order.order_number}</td>
//                     <td>{order.User?.Id}</td>
//                     <td>{order.User?.mobile}</td>
//                     <td>{order.Service?.services_name}</td>
//                     <td>
//                       <Badge
//                         className={`adminUserorder-badge-${order.status
//                           .toLowerCase()
//                           .replace(" ", "-")}`}
//                       >
//                         {order.status}
//                       </Badge>
//                     </td>
//                     <td>{order.price}Tk</td>
//                     {/* <td>{order.date}</td> */}
//                     <td>{formatDate(order.date)}</td>
//                     <td>{formatTimeDisplay(order.time)}</td>
//                     <td>{formatDeadlineTime(order.deadline)}</td>
//                     <td>
//                       <div className="adminUserorder-action-group">
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           className="adminUserorder-action-btn"
//                           onClick={() => handleViewDetails(order)}
//                         >
//                           <BsEye size={16} />
//                         </Button>
//                         <Button
//                           variant="outline-edit"
//                           size="sm"
//                           className="adminUserorder-action-btn"
//                           onClick={() => handleEditOrder(order)}
//                           disabled={editDisabled}
//                           title={
//                             editDisabled
//                               ? "Cannot edit when order is In-Progress or Completed"
//                               : "Edit schedule"
//                           }
//                         >
//                           <FaEdit size={16} />
//                         </Button>
//                         <Button
//                           variant="outline-danger"
//                           size="sm"
//                           className="adminUserorder-action-btn"
//                           onClick={() => handleDeleteOrder(order)}
//                         >
//                           <FaTrash size={16} />
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </Table>

//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />

//             {getPageItems(totalPages, currentPage).map((item, idx) => {
//               if (item === "start-ellipsis" || item === "end-ellipsis") {
//                 return <Pagination.Ellipsis key={item + idx} disabled />;
//               }
//               return (
//                 <Pagination.Item
//                   key={item}
//                   active={item === currentPage}
//                   onClick={() => handlePageChange(item)}
//                 >
//                   {item}
//                 </Pagination.Item>
//               );
//             })}

//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {showModal && (
//         <div className="adminUserorder-modal-backdrop" ref={modalRef}>
//           {renderOrderDetails()}
//         </div>
//       )}

//       {showEdit && editOrder && (
//         <div className="adminUserorder-modal-backdrop" ref={editModalRef}>
//           <div className="adminUserorder-modal">
//             {/* Header */}
//             <div className="adminUserorder-modal-header">
//               <button
//                 className="adminUserorder-modal-close"
//                 onClick={handleCloseEdit}
//               >
//                 <FaTimes size={20} />
//               </button>
//               <div>
//                 <h2 className="adminUserorder-modal-title">Edit Schedule</h2>
//                 <p className="adminUserorder-modal-subtitle">
//                   Order #{editOrder.order_number} •{" "}
//                   {editOrder.Service?.services_name}
//                 </p>
//               </div>
//             </div>

//             {/* Body */}
//             <div className="adminUserorder-modal-body">
//               {/* Date & Time (only) */}
//               {(() => {
//                 const { slots, minDateISO, minTimeInfo } = slotData;
//                 return (
//                   <Row className="mb-3">
//                     <Col md={6}>
//                       <Form.Group>
//                         <Form.Label>New Date</Form.Label>
//                         <Form.Control
//                           type="date"
//                           value={editForm.newDate}
//                           min={minDateISO}
//                           onChange={(e) =>
//                             setEditForm((f) => ({
//                               ...f,
//                               newDate: e.target.value,
//                             }))
//                           }
//                         />
//                         <div
//                           className="adminUserorder-detail-text"
//                           style={{ marginTop: 6 }}
//                         >
//                           Earliest allowed date: {minDateISO}
//                         </div>
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group>
//                         <Form.Label>New Time</Form.Label>
//                         <Form.Select
//                           value={editForm.newSlot}
//                           onChange={(e) =>
//                             setEditForm((f) => ({
//                               ...f,
//                               newSlot: e.target.value,
//                             }))
//                           }
//                           disabled={slots.length === 0}
//                         >
//                           {slots.length === 0 ? (
//                             <option value="">
//                               No available slots — pick another date
//                             </option>
//                           ) : (
//                             slots.map((s) => (
//                               <option key={s} value={s}>
//                                 {s}
//                               </option>
//                             ))
//                           )}
//                         </Form.Select>
//                         {minTimeInfo && (
//                           <div
//                             className="adminUserorder-detail-text"
//                             style={{ marginTop: 6 }}
//                           >
//                             {minTimeInfo}
//                           </div>
//                         )}
//                       </Form.Group>
//                     </Col>
//                   </Row>
//                 );
//               })()}

//               <Row className="mb-3">
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Check
//                       type="checkbox"
//                       id="reorder"
//                       label="Reorder (assign a new servitor)"
//                       checked={editForm.reorder}
//                       onChange={(e) =>
//                         setEditForm((f) => ({
//                           ...f,
//                           reorder: e.target.checked,
//                           // if reordering, must not keep current servitor
//                           keepServitor: e.target.checked
//                             ? false
//                             : f.keepServitor,
//                         }))
//                       }
//                     />
//                     <div
//                       className="adminUserorder-detail-text"
//                       style={{ marginTop: 6 }}
//                     >
//                       This will reset the order to <b>Pending</b> and clear the
//                       current servitor assignment, OTP/PIN and acceptance
//                       timestamps.
//                     </div>
//                   </Form.Group>
//                 </Col>
//               </Row>

//               <Row className="mb-3">
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Check
//                       type="checkbox"
//                       id="keep-servitor"
//                       label={
//                         editForm.reorder
//                           ? "Keep current servitor (disabled because Reorder is selected)"
//                           : forceKeepStatuses.includes(editOrder.status)
//                           ? "Keep current servitor (required for this status)"
//                           : "Keep current servitor (if already assigned)"
//                       }
//                       checked={
//                         editForm.reorder
//                           ? false
//                           : forceKeepStatuses.includes(editOrder.status)
//                           ? true
//                           : editForm.keepServitor
//                       }
//                       onChange={(e) =>
//                         setEditForm((f) => ({
//                           ...f,
//                           keepServitor: e.target.checked,
//                         }))
//                       }
//                       disabled={
//                         editForm.reorder ||
//                         forceKeepStatuses.includes(editOrder.status)
//                       }
//                     />

//                     <div
//                       className="adminUserorder-detail-text"
//                       style={{ marginTop: 6 }}
//                     >
//                       If unchecked (and order is not Accepted/In-Progress), any
//                       servitor assignment may be cleared.
//                     </div>
//                   </Form.Group>
//                 </Col>
//               </Row>

//               <Row>
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Label>Reason (optional)</Form.Label>
//                     <Form.Control
//                       as="textarea"
//                       rows={3}
//                       placeholder="Add a short note for audit (e.g., user requested to move to tomorrow)."
//                       value={editForm.reason}
//                       onChange={(e) =>
//                         setEditForm((f) => ({ ...f, reason: e.target.value }))
//                       }
//                     />
//                   </Form.Group>
//                 </Col>
//               </Row>
//             </div>

//             {/* Footer */}
//             <div className="adminUserorder-modal-footer">
//               <div className="adminUserorder-footer-buttons">
//                 <button
//                   className="adminUserorder-footer-btn adminUserorder-footer-btn-close"
//                   onClick={submitEdit}
//                   disabled={
//                     saving ||
//                     !editForm.newDate ||
//                     !editForm.newSlot ||
//                     slotData.slots.length === 0
//                   }
//                 >
//                   {saving ? (
//                     <Spinner animation="border" size="sm" />
//                   ) : (
//                     <FaCheck />
//                   )}
//                   {saving ? " Updating..." : "Update"}
//                 </button>
//                 <button
//                   className="adminUserorder-footer-btn adminUserorder-footer-btn-print"
//                   onClick={handleCloseEdit}
//                   disabled={saving}
//                 >
//                   <FaTimes /> Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </Container>
//   );
// };

// export default UserOrders;

// ***** Update with backend paginations and filter and search (19-Oct-2025) ***** //
// import React, { useEffect, useState, useRef, useMemo } from "react";
// import axios from "axios";
// import {
//   Table,
//   Container,
//   Card,
//   Pagination,
//   Badge,
//   Button,
//   InputGroup,
//   Form,
//   Row,
//   Col,
// } from "react-bootstrap";
// import { BsEye } from "react-icons/bs";
// import {
//   FaTimes,
//   FaBolt,
//   FaUser,
//   FaCheckCircle,
//   FaDollarSign,
//   FaCalendar,
//   FaPlusCircle,
//   FaWrench,
//   FaCogs,
//   FaStar,
//   FaUserCircle,
//   FaPhone,
//   FaIdBadge,
//   FaMapMarkerAlt,
//   FaClock,
//   FaPrint,
//   FaDownload,
//   FaCheck,
//   FaEdit,
//   // FaTrash,
//   FaBroom,
//   FaFire,
//   FaSnowflake,
//   FaFilter as FaFilterIcon,
//   FaUserGraduate,
//   FaKey 
// } from "react-icons/fa";
// import "./UserOrderStyle.css";
// import { Spinner } from "react-bootstrap";
// import { formatDate } from "../../dateTimefrontpart";
// import { URL } from "../../../config";
// import ReceiptGenerator from "../../User/Profile/ReceiptGenerator";


// /* ===========================
//    HELPERS — date/time utils
//    =========================== */
// const pad2 = (n) => String(n).padStart(2, "0");

// // normalize date to YYYY-MM-DD
// function toDateISO(raw) {
//   if (!raw) {
//     const d = new Date();
//     return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
//   }
//   const s = String(raw).trim();
//   if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
//   const d = new Date(s);
//   if (isNaN(d.getTime())) {
//     const n = new Date();
//     return `${n.getFullYear()}-${pad2(n.getMonth() + 1)}-${pad2(n.getDate())}`;
//   }
//   return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
// }

// const todayISO = () => {
//   const d = new Date();
//   return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
// };

// // "HH:mm" -> minutes since midnight
// function minutesFromHHmm(hhmm) {
//   if (!hhmm) return null;
//   const m = String(hhmm).match(/^(\d{1,2}):(\d{2})$/);
//   if (!m) return null;
//   return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
// }

// // "h:mm AM/PM" -> minutes since midnight
// function minutesFromAMPM(s) {
//   const m = String(s).match(/^\s*(\d{1,2})[:.](\d{2})\s*([AP]M)\s*$/i);
//   if (!m) return null;
//   let h = parseInt(m[1], 10);
//   const min = parseInt(m[2], 10);
//   const ampm = m[3].toUpperCase();
//   if (ampm === "PM" && h < 12) h += 12;
//   if (ampm === "AM" && h === 12) h = 0;
//   return h * 60 + min;
// }

// // accepts "HH:mm" or "h:mm AM/PM" and returns minutes
// function minutesFromAnyTime(t) {
//   if (!t) return null;
//   const s = String(t).trim();
//   const hhmm = s.match(/^\d{1,2}:\d{2}$/);
//   if (hhmm) return minutesFromHHmm(s);
//   return minutesFromAMPM(s);
// }

// function toAMPMFromMinutes(mins) {
//   if (mins == null) return "";
//   let h = Math.floor(mins / 60);
//   const m = mins % 60;
//   const am = h < 12;
//   let displayHour = h % 12;
//   if (displayHour === 0) displayHour = 12;
//   return `${displayHour}:${pad2(m)} ${am ? "AM" : "PM"}`;
// }

// // for display everywhere
// function formatTimeDisplay(raw) {
//   const mins = minutesFromAnyTime(raw);
//   if (mins == null) return String(raw ?? "");
//   return toAMPMFromMinutes(mins);
// }

// // For deadline
// function formatDeadlineTime(raw) {
//   if (!raw) return "-";
//   const d = new Date(raw);
//   if (isNaN(d.getTime())) return String(raw);
//   return toAMPMFromMinutes(d.getHours() * 60 + d.getMinutes());
// }

// // compute min date/time (cannot go earlier than current schedule; also not earlier than today)
// function getMinLimitsForOrder(order, { ignoreExisting = false } = {}) {
//   const schedDateISO = toDateISO(order?.date);
//   const schedTimeMins = minutesFromAnyTime(order?.time); // handles "16:30" or "4:30 PM"
//   const now = new Date();
//   const nowDateISO = todayISO();
//   const nowMins = now.getHours() * 60 + now.getMinutes();

//   // min date is the later of today vs scheduled date
//   const minDateISO = ignoreExisting
//     ? nowDateISO
//     : schedDateISO >= nowDateISO
//     ? schedDateISO
//     : nowDateISO;

//   // min time depends on chosen date
//   function computeMinTimeMins(newDateISO) {
//     if (!newDateISO) return null;
//     if (!ignoreExisting) {
//       if (newDateISO === schedDateISO && schedDateISO >= nowDateISO) {
//         return schedTimeMins ?? null;
//       }
//     }
//     if (newDateISO === nowDateISO) {
//       return nowMins;
//     }
//     return null;
//   }
//   return { minDateISO, computeMinTimeMins };
// }

// // generate 30-min slots (7:00–21:00), excluding slots < min on chosen day, and past slots today
// function generateSlotsAMPM(dateISO, minDateISO, minTimeMinsForThisDate) {
//   const slots = [];
//   if (!dateISO) return slots;

//   const startHour = 7;
//   const endHour = 21; // inclusive hour for last slot start (21:00)

//   const now = new Date();
//   const today = todayISO();
//   const isToday = dateISO === today;

//   const baseMin = minTimeMinsForThisDate ?? null; // boundary for this selected date

//   for (let h = startHour; h <= endHour; h++) {
//     for (let m = 0; m < 60; m += 30) {
//       const mins = h * 60 + m;

//       // block if selected date is before minDate
//       if (dateISO < minDateISO) continue;

//       // block if it's today and slot <= now
//       if (isToday) {
//         const nowMins = now.getHours() * 60 + now.getMinutes();
//         if (mins <= nowMins) continue;
//       }

//       // block if earlier than minimum boundary (previous schedule)
//       if (baseMin != null && mins < baseMin) continue;

//       slots.push(toAMPMFromMinutes(mins));
//     }
//   }
//   return slots;
// }
// /* =========================== */

// const UserOrders = () => {
//   // Table (server-driven) data
//   const [orders, setOrders] = useState([]);
//   const [meta, setMeta] = useState({
//     page: 1,
//     limit: 10,
//     total: 0,
//     totalPages: 1,
//     sortBy: "created_at",
//     sortDir: "DESC",
//     serviceType: "All",
//     status: "",
//     search: "",
//   });

//   // UI state
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   // Filters
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterType, setFilterType] = useState("All");
//   const [filterStatus, setFilterStatus] = useState("All");

//   // Detail modal
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const modalRef = useRef(null);

//   // Edit schedule modal
//   const [showEdit, setShowEdit] = useState(false);
//   const [editOrder, setEditOrder] = useState(null);
//   const [saving, setSaving] = useState(false);
//   const editModalRef = useRef(null);

//   // Servitor lookup state for Assign modal
//   const [servitorList, setServitorList] = useState([]); // the fetched rows
//   const [servitorQuery, setServitorQuery] = useState(""); // what admin types into the search
//   const [selectedServitor, setSelectedServitor] = useState(null); // chosen row

//   // Servitor Assign modal
//   const [showAssign, setShowAssign] = useState(false);
//   const [assignOrder, setAssignOrder] = useState(null);
//   const [assignForm, setAssignForm] = useState({
//     servitorId: "",
//     markApproved: false, // only relevant for Tutor Service
//     forceReassign: false, // allow reassign if admin wants to override
//   });
//   const [assigning, setAssigning] = useState(false);

//   const [invoiceOrder, setInvoiceOrder] = useState(null);


//   const openAssignModal = async (order) => {
//     setAssignOrder(order);
//     setAssignForm({
//       servitorId: "",
//       markApproved: false,
//       forceReassign: false,
//     });
//     setServitorList([]);
//     setServitorQuery("");
//     setSelectedServitor(null);
//     setShowAssign(true);
//     document.body.style.overflow = "hidden";

//     // Fetch list filtered by this order's service
//     try {
//       const svc = order?.Service?.services_name || "";
//       const { data } = await axios.get(`${URL}/admin/servitors`, {
//         params: { serviceType: svc, limit: 300 },
//       });
//       setServitorList(Array.isArray(data) ? data : []);
//     } catch (e) {
//       console.error("Failed to load servitors for assign:", e);
//     }
//   };

//   const closeAssignModal = () => {
//     setShowAssign(false);
//     setAssignOrder(null);
//     document.body.style.overflow = "auto";
//   };

//   const pickServitorByMobile = (mobile) => {
//     const s = servitorList.find((r) => String(r.mobile) === String(mobile));
//     if (s) {
//       setSelectedServitor(s);
//       setAssignForm((f) => ({ ...f, servitorId: s.Id })); // lock correct Id
//     } else {
//       setSelectedServitor(null);
//       setAssignForm((f) => ({ ...f, servitorId: "" }));
//     }
//   };

//   const [editForm, setEditForm] = useState({
//     newDate: "", // YYYY-MM-DD
//     newSlot: "", // "h:mm AM/PM"
//     keepServitor: false,
//     reason: "",
//     reorder: false,
//   });

//   const forceKeepStatuses = [
//     "Accepted",
//     "In-Progress",
//     "Cancelled by Servitor",
//   ];

//   const fetchOrders = async () => {
//     try {
//       const params = new URLSearchParams({
//         page: currentPage,
//         limit: itemsPerPage,
//         search: searchTerm || "",
//         status: filterStatus === "All" ? "" : filterStatus,
//         serviceType: filterType === "All" ? "" : filterType,
//         sortBy: "created_at",
//         sortDir: "DESC",
//       }).toString();

//       const { data } = await axios.get(`${URL}/all-user-orders?${params}`);
//       const { data: rows = [], meta: m = {} } = data || {};
//       setOrders(rows);
//       setMeta({
//         page: m.page || 1,
//         limit: m.limit || itemsPerPage,
//         total: m.total || 0,
//         totalPages: Math.max(1, m.totalPages || 1),
//         sortBy: m.sortBy || "created_at",
//         sortDir: m.sortDir || "DESC",
//         serviceType: m.serviceType || "All",
//         status: m.status || "",
//         search: m.search || "",
//       });
//     } catch (err) {
//       // 404 => no data; other errors => log
//       if (err?.response?.status === 404) {
//         setOrders([]);
//         setMeta((prev) => ({ ...prev, total: 0, totalPages: 1 }));
//       } else {
//         console.error("Error fetching orders:", err);
//       }
//     }
//   };

//   // Fetch on mount + on any filter/page change
//   useEffect(() => {
//     fetchOrders();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [currentPage, searchTerm, filterType, filterStatus]);

//   // ===== Details modal =====
//   const handleViewDetails = (order) => {
//     setSelectedOrder(order);
//     setShowModal(true);
//     document.body.style.overflow = "hidden";
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedOrder(null);
//     document.body.style.overflow = "auto";
//   };

//   useEffect(() => {
//     const node = modalRef.current;
//     const handleBackdropClick = (e) => {
//       if (node && e.target === node) {
//         handleCloseModal();
//       }
//     };
//     const handleEscapeKey = (e) => {
//       if (e.key === "Escape") {
//         handleCloseModal();
//       }
//     };
//     if (node) node.addEventListener("click", handleBackdropClick);
//     document.addEventListener("keydown", handleEscapeKey);
//     return () => {
//       if (node) node.removeEventListener("click", handleBackdropClick);
//       document.removeEventListener("keydown", handleEscapeKey);
//     };
//   }, []);

//   // ===== Edit schedule modal =====
//   const handleCloseEdit = () => {
//     setShowEdit(false);
//     setEditOrder(null);
//     setSaving(false);
//     document.body.style.overflow = "auto";
//   };

//   useEffect(() => {
//     const node = editModalRef.current;
//     const handleBackdropClick = (e) => {
//       if (node && e.target === node) handleCloseEdit();
//     };
//     const handleEscapeKey = (e) => {
//       if (e.key === "Escape") handleCloseEdit();
//     };
//     if (node) node.addEventListener("click", handleBackdropClick);
//     document.addEventListener("keydown", handleEscapeKey);
//     return () => {
//       if (node) node.removeEventListener("click", handleBackdropClick);
//       document.removeEventListener("keydown", handleEscapeKey);
//     };
//   }, []);

//   const handleEditOrder = (order) => {
//     if (!order) return;
//     const st = String(order.status || "").toLowerCase();
//     if (st === "in-progress") {
//       alert("In-Progress orders cannot be rescheduled.");
//       return;
//     }
//     if (st === "completed") {
//       alert("Completed orders cannot be rescheduled.");
//       return;
//     }

//     setEditOrder(order);

//     const dISO = toDateISO(order.date);
//     const timeAMPM = formatTimeDisplay(order.time);
//     const forceKeep = forceKeepStatuses.includes(order.status);

//     setEditForm({
//       newDate: dISO,
//       newSlot: timeAMPM,
//       keepServitor: forceKeep,
//       reason: "",
//       reorder: false,
//     });

//     setShowEdit(true);
//     document.body.style.overflow = "hidden";
//   };

//   // const handleDeleteOrder = (order) => {
//   //   console.log("Deleting order:", order);
//   //   // (optional) implement delete functionality here if you add a backend endpoint
//   // };

//   // recompute slot list when date/order changes
//   const slotData = useMemo(() => {
//     if (!editOrder)
//       return { slots: [], minDateISO: todayISO(), minTimeInfo: null };
//     const { minDateISO, computeMinTimeMins } = getMinLimitsForOrder(editOrder, {
//       ignoreExisting: !!editForm.reorder,
//     });
//     const minMins = computeMinTimeMins(editForm.newDate);
//     const slots = generateSlotsAMPM(editForm.newDate, minDateISO, minMins);

//     // ensure selected slot is valid; if not, pick first available
//     let selected = editForm.newSlot;
//     const found = slots.includes(selected);
//     if (!found && slots.length > 0) {
//       selected = slots[0];
//       setEditForm((f) => ({ ...f, newSlot: selected }));
//     }
//     return {
//       slots,
//       minDateISO,
//       minTimeInfo:
//         minMins != null
//           ? `Earliest allowed this day: ${toAMPMFromMinutes(minMins)}`
//           : null,
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [editOrder, editForm.newDate]);

//   const submitEdit = async () => {
//     if (!editOrder) return;

//     const st = String(editOrder.status || "").toLowerCase();
//     if (st === "in-progress" || st === "completed") {
//       alert("This order cannot be rescheduled.");
//       return;
//     }

//     if (!editForm.newDate || !editForm.newSlot) {
//       alert("Please select both a date and a time slot.");
//       return;
//     }

//     const serviceType = editOrder?.Service?.services_name || "";
//     const url = `${URL}/admin/orders/${encodeURIComponent(serviceType)}/${
//       editOrder.Id
//     }/reschedule`;

//     // Validate date/time against min limits
//     const { minDateISO, computeMinTimeMins } = getMinLimitsForOrder(editOrder, {
//       ignoreExisting: !!editForm.reorder,
//     });
//     if (editForm.newDate < minDateISO) {
//       alert("New date cannot be earlier than the current schedule/today.");
//       return;
//     }
//     const slotMins = minutesFromAMPM(editForm.newSlot);
//     const minMins = computeMinTimeMins(editForm.newDate);
//     if (minMins != null && slotMins < minMins) {
//       alert(`New time cannot be earlier than ${toAMPMFromMinutes(minMins)}.`);
//       return;
//     }

//     const payload = {
//       keepServitor: editForm.keepServitor,
//       reason: editForm.reason?.trim() || undefined,
//       reorder: !!editForm.reorder,
//       newDate: editForm.newDate,
//       newTime: editForm.newSlot, // backend accepts AM/PM
//     };

//     try {
//       setSaving(true);
//       const resp = await axios.post(url, payload);
//       alert(resp?.data?.message || "Order rescheduled");
//       // Refresh current page to keep server-driven list accurate
//       await fetchOrders();
//       handleCloseEdit();
//     } catch (err) {
//       console.error("Reschedule failed:", err);
//       const msg =
//         err?.response?.data?.message ||
//         err?.response?.data?.error ||
//         "Failed to reschedule";
//       alert(msg);
//     } finally {
//       setSaving(false);
//     }
//   };

//   // Pagination helpers
//   const indexOfFirstItem = (meta.page - 1) * meta.limit;
//   const totalPages = meta.totalPages || 1;

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);
//     if (current <= siblings + 2) {
//       end = Math.min(total - 1, maxButtons - 1);
//     }
//     if (current >= total - (siblings + 1)) {
//       start = Math.max(2, total - (maxButtons - 2));
//     }
//     if (start > 2) pages.push("start-ellipsis");
//     for (let i = start; i <= end; i++) pages.push(i);
//     if (end < total - 1) pages.push("end-ellipsis");
//     if (total > 1) pages.push(total);
//     return pages;
//   };

//   const handlePrintReceipt = () => {
//     console.log("Printing order receipt...");
//   };

//   // const handleDownloadInvoice = () => {
//   //   console.log("Downloading invoice...");
//   // };

//   const handleDownloadInvoice = () => {
//   if (!selectedOrder) {
//     alert("Open an order first to download its invoice.");
//     return;
//   }
//   setInvoiceOrder(selectedOrder);
// };


//   // build an ordered list of timeline steps
//   const buildTimeline = (order) => {
//     const steps = [];
//     steps.push({
//       key: "placed",
//       label: "Order Placed",
//       time: order.created_at,
//       dotClass: "completed",
//     });
//     if (order.accepted_at) {
//       steps.push({
//         key: "accepted",
//         label: "Order Accepted",
//         time: order.accepted_at,
//         dotClass:
//           order.status === "Accepted" ||
//           order.status === "In-Progress" ||
//           order.status === "Completed"
//             ? "completed"
//             : "inactive",
//       });
//     }
//     if (order.in_progress_at) {
//       steps.push({
//         key: "in_progress",
//         label: "Service In Progress",
//         time: order.in_progress_at,
//         dotClass:
//           order.status === "In-Progress" || order.status === "Completed"
//             ? "in-progress"
//             : "inactive",
//       });
//     }
//     if (order.completed_at) {
//       steps.push({
//         key: "completed",
//         label: "Order Completed",
//         time: order.completed_at,
//         dotClass: "arrived",
//       });
//     }
//     if (order.status && String(order.status).toLowerCase().includes("cancel")) {
//       steps.push({
//         key: "cancelled",
//         label: `Order ${order.status}`,
//         time: order.updated_at,
//         dotClass: "cancelled",
//       });
//     }
//     return steps;
//   };

//   const renderOrderDetails = () => {
//     if (!selectedOrder) return null;

//     const type = selectedOrder.service_name;
//     let icon = <FaBolt />;

//     // Build service-specific detail blocks
//     let details = {};
//     if (type === "Electrician") {
//       details = {
//         Installation: {
//           "New Ceiling Fan Installation":
//             selectedOrder.new_ceiling_fan_installation,
//           "Ceiling Fan Installation": selectedOrder.ceiling_fan_installation,
//           "Ceiling Fan Uninstallation":
//             selectedOrder.ceiling_fan_uninstallation,
//           "Light Installation": selectedOrder.light_installation,
//           "Exhaust Fan Installation": selectedOrder.exhaust_fan_installation,
//           "Doorbell Installation": selectedOrder.doorbell_installation,
//           "Switch Setup": selectedOrder.switch_setup,
//           "Socket Setup": selectedOrder.socket_setup,
//           "Regulator Setup": selectedOrder.regulator_setup,
//           "IPS Installation (Existing Line)":
//             selectedOrder.ips_installation_existing_line,
//           "IPS New Line Installation": selectedOrder.ips_new_line_installation,
//         },
//         Repair: {
//           "Fan Coil Repair": selectedOrder.fan_coil_repair,
//           "Light Repair": selectedOrder.light_repair,
//         },
//         Maintenance: {
//           "Fan Coil New Winding": selectedOrder.fan_coil_new_winding,
//           "Capacitor Setup": selectedOrder.capacitor_setup,
//           "Exhaust Fan Cleaning": selectedOrder.exhaust_fan_cleaning,
//           "Main Circuit Board Setup": selectedOrder.main_circuit_board_setup,
//         },
//         Additional: {
//           "New Wiring Point": selectedOrder.new_wiring_point,
//           "Drill Hole Service": selectedOrder.drill_hole_service,
//           "Electrical Checkup": selectedOrder.Electrical_checkup ? "Yes" : "No",
//         },
//       };
//       icon = <FaBolt />;
//     } else if (type === "Home Cleaning") {
//       details = {
//         "Room Cleaning": {
//           "Bed Cleaning": selectedOrder.bed,
//           "Bathroom Cleaning": selectedOrder.bath,
//           "Drawing/Dining Cleaning": selectedOrder.dra_din,
//           "Balcony Cleaning": selectedOrder.balcony,
//           "Kitchen Cleaning": selectedOrder.kitchen,
//           "Satirs & Railing Cleaning": selectedOrder.stairs_and_railing,
//         },
//         "Additional Cleaning": {
//           "Window & Grill Cleaning": selectedOrder.window_grill,
//           "Furniture Cleaning": selectedOrder.furniture_cleaning,
//           "Cloth Washing": selectedOrder.cloth,
//           "Dish Washing": selectedOrder.dish,
//           "Carpet Cleaning": selectedOrder.carpet_cleaning,
//         },
//       };
//       icon = <FaBroom />;
//     } else if (type === "Plumber") {
//       details = {
//         Installation: {
//           "Angle Valve Setup": selectedOrder.angle_valve_setup,
//           "Basin Tap (Faucet) Setup": selectedOrder.basin_tap_setup,
//           "Magic Pipe (Flexible Drain) Setup": selectedOrder.magic_pipe_setup,
//           "Basin Waste / Pop-Up Setup": selectedOrder.basin_waste_pop_up_setup,
//           "New Basin Setup (existing lines)":
//             selectedOrder.new_basin_setup_existing_lines,
//           "Bathroom Tap Setup": selectedOrder.bathroom_tap_bib_cock_setup,
//           "Tissue Holder Setup": selectedOrder.tissue_holder_setup,
//           "Hand Shower Setup": selectedOrder.hand_shower_setup,
//           "Soap Dish Setup": selectedOrder.soap_dish_setup,
//           "Bathroom Shelf Setup": selectedOrder.bathroom_shelf_setup,
//           "Looking Glass/Mirror Setup": selectedOrder.mirror_setup,
//           "Towel Hanger / Ring Setup": selectedOrder.towel_hanger_setup,
//           "Shower Head + Hose Setup": selectedOrder.shower_head_setup,
//           "Concealed Stopcock Valve Setup":
//             selectedOrder.concealed_stopcock_setup,
//           "Floor Drain Net Setup": selectedOrder.floor_drain_net_setup,
//           "Toilet Seat Complete Installation":
//             selectedOrder.toilet_seat_complete_installation,
//           "High Commode Installation (existing lines)":
//             selectedOrder.high_commode_installation_existing_lines,
//           "Kitchen Sink Setup (existing lines)":
//             selectedOrder.kitchen_sink_setup_existing_lines,
//           "Geyser Installation": selectedOrder.geyser_installation,
//           "Washing Machine Point Setup (existing Line)":
//             selectedOrder.washing_machine_point_setup,
//         },
//         Repair: {
//           "Toilet Seat Cover Replacement":
//             selectedOrder.toilet_seat_cover_replacement,
//           "Fill Valve Replacement (High Commode)":
//             selectedOrder.fill_valve_replacement,
//           "Blockage Clearing — High Commode":
//             selectedOrder.blockage_clearing_high_commode,
//           "Blockage Clearing — Low Commode":
//             selectedOrder.blockage_clearing_low_commode,
//         },
//         Maintenance: {
//           "Bathroom Drain Line Cleaning (per bathroom)":
//             selectedOrder.bathroom_drain_line_cleaning,
//           "Sink Blockage Cleaning": selectedOrder.sink_blockage_cleaning,
//         },
//         Additional: {
//           "Plumbing Checkup / Diagnosis": selectedOrder.issue_checkup
//             ? "Yes"
//             : "No",
//         },
//       };
//       icon = <FaCogs />;
//     } else if (type === "Gas Chula") {
//       details = {
//         Installation: {
//           "Cylinder Type": selectedOrder.chulaCylinderType,
//           "New Chula Setup": selectedOrder.NewchulaSetup,
//           "Chula Setup": selectedOrder.chulaSetup,
//           "Burner Setup": selectedOrder.burnerSetup,
//         },
//         Maintenance: {
//           "Burner Cleaning": selectedOrder.burnerCleaning,
//           "Nozzle Replacement": selectedOrder.nozzleReplacement,
//           "Check Issues": selectedOrder.checkIssues ? "Yes" : "No",
//         },
//       };
//       icon = <FaFire />;
//     } else if (type === "AC Service") {
//       const n = (v) => (v == null || isNaN(Number(v)) ? 0 : Number(v));
//       details = {
//         Specifications: {
//           "AC Type": selectedOrder.acType || "-",
//           "AC Ton": selectedOrder.acTon || "-",
//         },
//         // Installation: {
//         //   "New Setup": selectedOrder.new_setup,
//         //   Installation: selectedOrder.installation,
//         //   Uninstallation: selectedOrder.uninstallation,
//         // },
//         // Maintenance: {
//         //   "Gas Refill": selectedOrder.gas_refill,
//         //   Cleaning: selectedOrder.cleaning,
//         //   "Issue Checkup": selectedOrder.issue_checkup ? "Yes" : "No",
//         // },

//         Installation: {
//           "AC Install (Outdoor Unit Inside)": n(
//             selectedOrder.installation_outdoor_inside
//           ),
//           "AC Install (Outdoor Unit Outside)": n(
//             selectedOrder.installation_outdoor_outside
//           ),
//         },
//         Uninstallation: {
//           "AC Uninstall (Outdoor Unit Inside)": n(
//             selectedOrder.uninstallation_outdoor_inside
//           ),
//           "AC Uninstall (Outdoor Unit Outside)": n(
//             selectedOrder.uninstallation_outdoor_outside
//           ),
//         },
//         Maintenance: {
//           "AC Cleaning (Outdoor Unit Inside)": n(
//             selectedOrder.cleaning_outdoor_inside
//           ),
//           "AC Cleaning (Outdoor Unit Outside)": n(
//             selectedOrder.cleaning_outdoor_outside
//           ),
//           "Issue Checkup (units)": n(selectedOrder.issue_checkup),
//         },
//       };
//       icon = <FaSnowflake />;
//     } else if (type === "Filter") {
//       details = {
//         Specifications: {
//           "Filter Type": selectedOrder.filter_type || "-",
//         },
//         Additional: {
//           "Issue Checkup": selectedOrder.check_up ? "Yes" : "No",
//         },
//         Installation: {
//           "New Filter Setup": selectedOrder.new_filter_setup,
//           "Filter Installation": selectedOrder.installation_filter,
//           "Filter Uninstallation": selectedOrder.uninstallation_filter,
//         },
//         Maintenance: {
//           "Kit Replacement": selectedOrder.kit_replacement,
//           "Pipe Leak / Replace": selectedOrder.pipe_leak_or_replace,
//           "Full Servicing": selectedOrder.full_servicing,
//         },
//       };
//       icon = <FaFilterIcon />;
//     } else if (type === "Tutor Service") {
//       const clean = (v) =>
//         v !== undefined &&
//         v !== null &&
//         String(v).trim() !== "" &&
//         String(v).trim().toLowerCase() !== "any";

//       const core = {};
//       if (clean(selectedOrder.subject)) core["Subject"] = selectedOrder.subject;
//       if (clean(selectedOrder.classLevel))
//         core["Class/Level"] = selectedOrder.classLevel;
//       if (clean(selectedOrder.medium)) core["Medium"] = selectedOrder.medium;

//       const schedule = {};
//       if (clean(selectedOrder.daysPerWeek))
//         schedule["Days per Week"] = `${selectedOrder.daysPerWeek}`;
//       if (clean(selectedOrder.hoursPerDay))
//         schedule["Hours per Day"] = `${selectedOrder.hoursPerDay}`;
//       if (clean(selectedOrder.salary))
//         schedule["Salary"] = `৳${selectedOrder.salary}`;

//       const prefs = {};
//       if (clean(selectedOrder.preferredTutorGender))
//         prefs["Preferred Tutor Gender"] = selectedOrder.preferredTutorGender;
//       if (clean(selectedOrder.priorityInstitution))
//         prefs["Priority Institution"] = selectedOrder.priorityInstitution;

//       details = {};
//       if (Object.keys(core).length) details["Tutoring"] = core;
//       if (Object.keys(schedule).length) details["Schedule & Budget"] = schedule;
//       if (Object.keys(prefs).length) details["Preferences"] = prefs;

//       icon = <FaUserGraduate />;
//     }

//     return (
//       <div className="adminUserorder-modal">
//         {/* Modal Header */}
//         <div className="adminUserorder-modal-header">
//           <button
//             className="adminUserorder-modal-close"
//             onClick={handleCloseModal}
//           >
//             <FaTimes size={20} />
//           </button>
//           <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//             <div className="adminUserorder-service-icon">{icon}</div>
//             <div>
//               <h2 className="adminUserorder-modal-title">Order Details</h2>
//               <p className="adminUserorder-modal-subtitle">
//                 Order #{selectedOrder.order_number} • {type} Service
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Modal Body */}
//         <div className="adminUserorder-modal-body">
//           {/* Summary Cards */}
//           <div className="adminUserorder-summary-cards">
//             <div className="adminUserorder-summary-card adminUserorder-status-card">
//               <div>
//                 <p className="adminUserorder-detail-text">Status</p>
//                 <span
//                   className={`adminUserorder-badge-${selectedOrder.status
//                     .toLowerCase()
//                     .replace(" ", "-")}`}
//                 >
//                   {selectedOrder.status}
//                 </span>
//               </div>
//               <FaCheckCircle size={24} style={{ color: "#22c55e" }} />
//             </div>

//             <div className="adminUserorder-summary-card adminUserorder-price-card">
//               <div>
//                 <p className="adminUserorder-detail-text">Total Amount</p>
//                 <p className="adminUserorder-price-value">
//                   ৳{selectedOrder.price}
//                 </p>
//               </div>
//               <FaDollarSign size={24} style={{ color: "#2563eb" }} />
//             </div>

//             <div className="adminUserorder-summary-card adminUserorder-date-card">
//               <div>
//                 <p className="adminUserorder-detail-text">Service Date</p>
//                 <p className="adminUserorder-date-value">
//                   {selectedOrder.date}
//                 </p>
//                 <p className="adminUserorder-time-value">
//                   {selectedOrder.time}
//                 </p>
//               </div>
//               <FaCalendar size={24} style={{ color: "#7c3aed" }} />
//             </div>
//           </div>

//           {/* Customer Information */}
//           <div className="adminUserorder-detail-card">
//             <h3 className="adminUserorder-detail-title">
//               <FaUser
//                 style={{ marginRight: "8px", color: "var(--primary-color)" }}
//               />
//               Customer Information
//             </h3>
//             <div className="adminUserorder-customer-grid">
//               <div>
//                 <div className="adminUserorder-customer-info">
//                   <FaUserCircle className="adminUserorder-customer-icon" />
//                   <div>
//                     <p className="adminUserorder-detail-text">Customer Name</p>
//                     <p className="adminUserorder-detail-value">
//                       {selectedOrder.User?.FirstName}{" "}
//                       {selectedOrder.User?.LastName}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminUserorder-customer-info">
//                   <FaPhone className="adminUserorder-customer-icon" />
//                   <div>
//                     <p className="adminUserorder-detail-text">Mobile Number</p>
//                     <p className="adminUserorder-detail-value">
//                       {selectedOrder.User?.mobile}
//                     </p>
//                   </div>
//                 </div>

//                 {/* This one is only for Temporary for manual order */}
//                 <div className="adminUserorder-customer-info">
//                   <FaKey className="adminUserorder-customer-icon" />
//                   <div>
//                     <p className="adminUserorder-detail-text">Verification Code</p>
//                     <p className="adminUserorder-detail-value">
//                       {selectedOrder.verification_pin}
//                     </p>
//                   </div>
//                 </div>
                
//               </div>
//               <div>
//                 <div className="adminUserorder-customer-info">
//                   <FaIdBadge className="adminUserorder-customer-icon" />
//                   <div>
//                     <p className="adminUserorder-detail-text">User ID</p>
//                     <p className="adminUserorder-detail-value">
//                       {selectedOrder.User?.Id}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminUserorder-customer-info">
//                   <FaMapMarkerAlt className="adminUserorder-customer-icon" />
//                   <div>
//                     <p className="adminUserorder-detail-text">
//                       Service Location
//                     </p>
//                     <p className="adminUserorder-detail-value">
//                       {[
//                         selectedOrder.City,
//                         selectedOrder.Area,
//                         selectedOrder.Address,
//                       ]
//                         .filter(Boolean)
//                         .join(" - ")}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {["Accepted", "Completed", "Cancelled by Servitor"].includes(
//             selectedOrder.status
//           ) && (
//             <div className="adminUserorder-detail-card">
//               <h3 className="adminUserorder-detail-title">
//                 <FaUser
//                   style={{ marginRight: "8px", color: "var(--primary-color)" }}
//                 />
//                 Servitor Information
//               </h3>
//               <div className="adminUserorder-customer-grid">
//                 <div>
//                   <div className="adminUserorder-customer-info">
//                     <FaUserCircle className="adminUserorder-customer-icon" />
//                     <div>
//                       <p className="adminUserorder-detail-text">
//                         Servitor Name
//                       </p>
//                       <p className="adminUserorder-detail-value">
//                         {selectedOrder.Servitor?.FirstName}{" "}
//                         {selectedOrder.Servitor?.LastName}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminUserorder-customer-info">
//                     <FaPhone className="adminUserorder-customer-icon" />
//                     <div>
//                       <p className="adminUserorder-detail-text">
//                         Mobile Number
//                       </p>
//                       <p className="adminUserorder-detail-value">
//                         {selectedOrder.Servitor?.mobile}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//                 <div>
//                   <div className="adminUserorder-customer-info">
//                     <FaIdBadge className="adminUserorder-customer-icon" />
//                     <div>
//                       <p className="adminUserorder-detail-text">NID</p>
//                       <p className="adminUserorder-detail-value">
//                         {selectedOrder.Servitor?.NID}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="adminUserorder-customer-info">
//                     <FaMapMarkerAlt className="adminUserorder-customer-icon" />
//                     <div>
//                       <p className="adminUserorder-detail-text">Address</p>
//                       <p className="adminUserorder-detail-value">
//                         {[
//                           selectedOrder.Servitor?.city,
//                           selectedOrder.Servitor?.area,
//                           selectedOrder.Servitor?.Address,
//                         ]
//                           .filter(Boolean)
//                           .join(" - ")}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Service Details */}
//           <div className="adminUserorder-detail-card">
//             <h3 className="adminUserorder-detail-title">
//               {type} Service Details
//             </h3>
//             <div className="adminUserorder-service-grid">
//               {Object.entries(details).map(([category, items]) => (
//                 <div key={category} className="adminUserorder-service-category">
//                   <h4 className="adminUserorder-category-title">
//                     {category === "Installation" && (
//                       <FaPlusCircle
//                         style={{ marginRight: "8px", color: "#22c55e" }}
//                       />
//                     )}
//                     {category === "Repair" && (
//                       <FaWrench
//                         style={{ marginRight: "8px", color: "#f59e0b" }}
//                       />
//                     )}
//                     {category === "Maintenance" && (
//                       <FaCogs
//                         style={{ marginRight: "8px", color: "#3b82f6" }}
//                       />
//                     )}
//                     {category === "Additional" && (
//                       <FaStar
//                         style={{ marginRight: "8px", color: "#7c3aed" }}
//                       />
//                     )}
//                     {category === "Room Cleaning" && (
//                       <FaBroom
//                         style={{ marginRight: "8px", color: "#10b981" }}
//                       />
//                     )}
//                     {category === "Additional Cleaning" && (
//                       <FaStar
//                         style={{ marginRight: "8px", color: "#7c3aed" }}
//                       />
//                     )}
//                     {category === "Specifications" && (
//                       <FaSnowflake
//                         style={{ marginRight: "8px", color: "#7c3aed" }}
//                       />
//                     )}
//                     {category === "Tutoring" && (
//                       <FaUserGraduate
//                         style={{ marginRight: "8px", color: "#2563eb" }}
//                       />
//                     )}
//                     {category === "Schedule & Budget" && (
//                       <FaCalendar
//                         style={{ marginRight: "8px", color: "#7c3aed" }}
//                       />
//                     )}
//                     {category === "Preferences" && (
//                       <FaStar
//                         style={{ marginRight: "8px", color: "#f59e0b" }}
//                       />
//                     )}
//                     {category}
//                   </h4>
//                   <div
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       gap: "8px",
//                     }}
//                   >
//                     {Object.entries(items).map(([key, value]) => (
//                       <div
//                         key={key}
//                         className={`adminUserorder-service-item ${
//                           value === 0 || value === "No" ? "inactive" : ""
//                         }`}
//                       >
//                         <span
//                           className={`adminUserorder-service-name ${
//                             value === 0 || value === "No" ? "inactive" : ""
//                           }`}
//                         >
//                           {key}
//                         </span>
//                         <span
//                           className={`adminUserorder-service-value${
//                             value === 0 || value === "No" ? "-inactive" : ""
//                           }`}
//                         >
//                           {value}
//                         </span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="adminUserorder-detail-card">
//             <h3 className="adminUserorder-detail-title">
//               <FaClock
//                 style={{ marginRight: "8px", color: "var(--primary-color)" }}
//               />
//               Order Timeline
//             </h3>
//             <div
//               style={{ display: "flex", flexDirection: "column", gap: "16px" }}
//             >
//               {buildTimeline(selectedOrder).map((step) => (
//                 <div key={step.key} className="adminUserorder-timeline-item">
//                   {step.key === "cancelled" ? (
//                     <FaTimes
//                       size={16}
//                       className="adminUserorder-timeline-cancel-icon"
//                     />
//                   ) : (
//                     <div
//                       className={`adminUserorder-timeline-dot ${step.dotClass}`}
//                     ></div>
//                   )}
//                   <div className="adminUserorder-timeline-content">
//                     <h4>{step.label}</h4>
//                     <p>{new Date(step.time).toLocaleString()}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {selectedOrder.customerFeedback != null && (
//             <div className="adminUserorder-detail-card">
//               <h3 className="adminUserorder-detail-title">
//                 <FaStar style={{ marginRight: 8, color: "#f59e0b" }} />
//                 Customer Feedback
//               </h3>
//               <p className="adminUserorder-detail-value">
//                 {selectedOrder.customerFeedback}
//               </p>
//             </div>
//           )}

//           {(() => {
//             const fb = selectedOrder?.cancellation_feedback;
//             const hasFeedback =
//               typeof fb === "string" ? fb.trim().length > 0 : !!fb;

//             return (
//               hasFeedback && (
//                 <div className="adminUserorder-detail-card">
//                   <h3 className="adminUserorder-detail-title">
//                     <FaTimes style={{ marginRight: "8px", color: "#ef4444" }} />
//                     Cancellation Feedback
//                   </h3>
//                   <p className="adminUserorder-detail-value">{fb}</p>
//                 </div>
//               )
//             );
//           })()}
//         </div>

//         {/* Modal Footer */}
//         <div className="adminUserorder-modal-footer">
//           <div className="adminUserorder-footer-buttons">
//             <button
//               className="adminUserorder-footer-btn adminUserorder-footer-btn-print"
//               onClick={handlePrintReceipt}
//             >
//               <FaPrint />
//               Print Receipt
//             </button>
//             <button
//               className="adminUserorder-footer-btn adminUserorder-footer-btn-download"
//               onClick={handleDownloadInvoice}
//             >
//               <FaDownload />
//               Download Invoice
//             </button>
//             <button
//               className="adminUserorder-footer-btn adminUserorder-footer-btn-close"
//               onClick={handleCloseModal}
//             >
//               <FaCheck />
//               Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <Container fluid className="adminUserorder-container">
//       <Card className="adminUserorder-card">
//         <Card.Body>
//           <Card.Header className="adminUserorder-header">
//             <h4 className="adminUserorder-title">All User Orders</h4>
//           </Card.Header>

//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by Order Number, User ID or Mobile Number"
//                   value={searchTerm}
//                   onChange={(e) => {
//                     setSearchTerm(e.target.value);
//                     setCurrentPage(1); // reset page when searching
//                   }}
//                   className="adminUserorder-search"
//                 />
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Group controlId="statusFilter">
//                 <Form.Select
//                   value={filterStatus}
//                   onChange={(e) => {
//                     setFilterStatus(e.target.value);
//                     setCurrentPage(1); // reset page on filter change
//                   }}
//                   className="adminUserorder-filter-select"
//                 >
//                   <option value="All">All Statuses</option>
//                   <option value="Pending">Pending</option>
//                   <option value="Accepted">Accepted</option>
//                   <option value="In-Progress">In-Progress</option>
//                   <option value="Cancelled">Cancelled</option>
//                   <option value="Cancelled by Servitor">
//                     Cancelled by Servitor
//                   </option>
//                   <option value="Completed">Completed</option>
//                   <option value="Deadline-Timeout">Deadline-Timeout</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="adminUserorder-filter-container">
//             {[
//               "All",
//               "Electrician",
//               "Home Cleaning",
//               "Plumber",
//               "Gas Chula",
//               "AC Service",
//               "Filter",
//               "Tutor Service",
//             ].map((type) => (
//               <Button
//                 key={type}
//                 variant={filterType === type ? "primary" : "outline-primary"}
//                 className="adminUserorder-filter-btn"
//                 onClick={() => {
//                   setFilterType(type);
//                   setCurrentPage(1); // reset page on filter change
//                 }}
//               >
//                 {type}
//               </Button>
//             ))}
//           </div>

//           <Table
//             striped
//             bordered
//             hover
//             responsive
//             className="adminUserorder-table"
//           >
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Order number</th>
//                 <th>User ID</th>
//                 <th>Mobile</th>
//                 <th>Service</th>
//                 <th>Status</th>
//                 <th>Price</th>
//                 <th>Date</th>
//                 <th>Time</th>
//                 <th>Deadline</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {orders.length === 0 ? (
//                 <tr>
//                   <td colSpan={11} className="text-center text-muted">
//                     No orders found.
//                   </td>
//                 </tr>
//               ) : (
//                 orders.map((order, index) => {
//                   const statusLC = String(order.status || "").toLowerCase();
//                   const editDisabled =
//                     statusLC === "in-progress" || statusLC === "completed";
//                   return (
//                     <tr key={`${order.order_number}-${order.Id}`}>
//                       <td>{index + 1 + indexOfFirstItem}</td>
//                       <td>{order.order_number}</td>
//                       <td>{order.User?.Id}</td>
//                       <td>{order.User?.mobile}</td>
//                       <td>{order.Service?.services_name}</td>
//                       <td>
//                         <Badge
//                           className={`adminUserorder-badge-${order.status
//                             .toLowerCase()
//                             .replace(" ", "-")}`}
//                         >
//                           {order.status}
//                         </Badge>
//                       </td>
//                       <td>{order.price}Tk</td>
//                       <td>{formatDate(order.date)}</td>
//                       <td>{formatTimeDisplay(order.time)}</td>
//                       <td>{formatDeadlineTime(order.deadline)}</td>
//                       <td>
//                         <div className="adminUserorder-action-group">
//                           <Button
//                             variant="outline-primary"
//                             size="sm"
//                             className="adminUserorder-action-btn"
//                             onClick={() => handleViewDetails(order)}
//                           >
//                             <BsEye size={16} />
//                           </Button>
//                           <Button
//                             variant="outline-edit"
//                             size="sm"
//                             className="adminUserorder-action-btn"
//                             onClick={() => handleEditOrder(order)}
//                             disabled={editDisabled}
//                             title={
//                               editDisabled
//                                 ? "Cannot edit when order is In-Progress or Completed"
//                                 : "Edit schedule"
//                             }
//                           >
//                             <FaEdit size={16} />
//                           </Button>
//                           {/* <Button
//                             variant="outline-danger"
//                             size="sm"
//                             className="adminUserorder-action-btn"
//                             onClick={() => handleDeleteOrder(order)}
//                           >
//                             <FaTrash size={16} />
//                           </Button> */}

//                           {["pending", "Deadline-Timeout", "Accepted"].includes(
//                             order.status
//                           ) && (
//                             <Button
//                               variant="outline-success"
//                               size="sm"
//                               className="adminUserorder-action-btn"
//                               onClick={() => openAssignModal(order)}
//                               title="Assign a servitor to this order"
//                             >
//                               <FaCheckCircle size={16} />
//                             </Button>
//                           )}
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })
//               )}
//             </tbody>
//           </Table>

//           {/* Pagination (server-driven) */}
//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
//               disabled={currentPage === 1}
//             />

//             {getPageItems(totalPages, currentPage).map((item, idx) => {
//               if (item === "start-ellipsis" || item === "end-ellipsis") {
//                 return <Pagination.Ellipsis key={item + idx} disabled />;
//               }
//               return (
//                 <Pagination.Item
//                   key={item}
//                   active={item === currentPage}
//                   onClick={() => handlePageChange(item)}
//                 >
//                   {item}
//                 </Pagination.Item>
//               );
//             })}

//             <Pagination.Next
//               onClick={() =>
//                 handlePageChange(Math.min(totalPages, currentPage + 1))
//               }
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {showModal && (
//         <div className="adminUserorder-modal-backdrop" ref={modalRef}>
//           {renderOrderDetails()}
//         </div>
//       )}

//       {showEdit && editOrder && (
//         <div className="adminUserorder-modal-backdrop" ref={editModalRef}>
//           <div className="adminUserorder-modal">
//             {/* Header */}
//             <div className="adminUserorder-modal-header">
//               <button
//                 className="adminUserorder-modal-close"
//                 onClick={handleCloseEdit}
//               >
//                 <FaTimes size={20} />
//               </button>
//               <div>
//                 <h2 className="adminUserorder-modal-title">Edit Schedule</h2>
//                 <p className="adminUserorder-modal-subtitle">
//                   Order #{editOrder.order_number} •{" "}
//                   {editOrder.Service?.services_name}
//                 </p>
//               </div>
//             </div>

//             {/* Body */}
//             <div className="adminUserorder-modal-body">
//               {/* Date & Time (only) */}
//               {(() => {
//                 const { slots, minDateISO, minTimeInfo } = slotData;
//                 return (
//                   <Row className="mb-3">
//                     <Col md={6}>
//                       <Form.Group>
//                         <Form.Label>New Date</Form.Label>
//                         <Form.Control
//                           type="date"
//                           value={editForm.newDate}
//                           min={minDateISO}
//                           onChange={(e) =>
//                             setEditForm((f) => ({
//                               ...f,
//                               newDate: e.target.value,
//                             }))
//                           }
//                         />
//                         <div
//                           className="adminUserorder-detail-text"
//                           style={{ marginTop: 6 }}
//                         >
//                           Earliest allowed date: {minDateISO}
//                         </div>
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group>
//                         <Form.Label>New Time</Form.Label>
//                         <Form.Select
//                           value={editForm.newSlot}
//                           onChange={(e) =>
//                             setEditForm((f) => ({
//                               ...f,
//                               newSlot: e.target.value,
//                             }))
//                           }
//                           disabled={slots.length === 0}
//                         >
//                           {slots.length === 0 ? (
//                             <option value="">
//                               No available slots — pick another date
//                             </option>
//                           ) : (
//                             slots.map((s) => (
//                               <option key={s} value={s}>
//                                 {s}
//                               </option>
//                             ))
//                           )}
//                         </Form.Select>
//                         {minTimeInfo && (
//                           <div
//                             className="adminUserorder-detail-text"
//                             style={{ marginTop: 6 }}
//                           >
//                             {minTimeInfo}
//                           </div>
//                         )}
//                       </Form.Group>
//                     </Col>
//                   </Row>
//                 );
//               })()}

//               <Row className="mb-3">
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Check
//                       type="checkbox"
//                       id="reorder"
//                       label="Reorder (assign a new servitor)"
//                       checked={editForm.reorder}
//                       onChange={(e) =>
//                         setEditForm((f) => ({
//                           ...f,
//                           reorder: e.target.checked,
//                           // if reordering, must not keep current servitor
//                           keepServitor: e.target.checked
//                             ? false
//                             : f.keepServitor,
//                         }))
//                       }
//                     />
//                     <div
//                       className="adminUserorder-detail-text"
//                       style={{ marginTop: 6 }}
//                     >
//                       This will reset the order to <b>Pending</b> and clear the
//                       current servitor assignment, OTP/PIN and acceptance
//                       timestamps.
//                     </div>
//                   </Form.Group>
//                 </Col>
//               </Row>

//               <Row className="mb-3">
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Check
//                       type="checkbox"
//                       id="keep-servitor"
//                       label={
//                         editForm.reorder
//                           ? "Keep current servitor (disabled because Reorder is selected)"
//                           : forceKeepStatuses.includes(editOrder.status)
//                           ? "Keep current servitor (required for this status)"
//                           : "Keep current servitor (if already assigned)"
//                       }
//                       checked={
//                         editForm.reorder
//                           ? false
//                           : forceKeepStatuses.includes(editOrder.status)
//                           ? true
//                           : editForm.keepServitor
//                       }
//                       onChange={(e) =>
//                         setEditForm((f) => ({
//                           ...f,
//                           keepServitor: e.target.checked,
//                         }))
//                       }
//                       disabled={
//                         editForm.reorder ||
//                         forceKeepStatuses.includes(editOrder.status)
//                       }
//                     />

//                     <div
//                       className="adminUserorder-detail-text"
//                       style={{ marginTop: 6 }}
//                     >
//                       If unchecked (and order is not Accepted/In-Progress), any
//                       servitor assignment may be cleared.
//                     </div>
//                   </Form.Group>
//                 </Col>
//               </Row>

//               <Row>
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Label>Reason (optional)</Form.Label>
//                     <Form.Control
//                       as="textarea"
//                       rows={3}
//                       placeholder="Add a short note for audit (e.g., user requested to move to tomorrow)."
//                       value={editForm.reason}
//                       onChange={(e) =>
//                         setEditForm((f) => ({ ...f, reason: e.target.value }))
//                       }
//                     />
//                   </Form.Group>
//                 </Col>
//               </Row>
//             </div>

//             {/* Footer */}
//             <div className="adminUserorder-modal-footer">
//               <div className="adminUserorder-footer-buttons">
//                 <button
//                   className="adminUserorder-footer-btn adminUserorder-footer-btn-close"
//                   onClick={submitEdit}
//                   disabled={
//                     saving ||
//                     !editForm.newDate ||
//                     !editForm.newSlot ||
//                     slotData.slots.length === 0
//                   }
//                 >
//                   {saving ? (
//                     <Spinner animation="border" size="sm" />
//                   ) : (
//                     <FaCheck />
//                   )}
//                   {saving ? " Updating..." : "Update"}
//                 </button>
//                 <button
//                   className="adminUserorder-footer-btn adminUserorder-footer-btn-print"
//                   onClick={handleCloseEdit}
//                   disabled={saving}
//                 >
//                   <FaTimes /> Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Assign servitor by admin */}

//       {showAssign && assignOrder && (
//         <div
//           className="adminUserorder-modal-backdrop"
//           onClick={(e) => e.target === e.currentTarget && closeAssignModal()}
//         >
//           <div className="adminUserorder-modal" role="dialog" aria-modal="true">
//             <div className="adminUserorder-modal-header">
//               <button
//                 className="adminUserorder-modal-close"
//                 onClick={closeAssignModal}
//               >
//                 <FaTimes size={20} />
//               </button>
//               <div>
//                 <h2 className="adminUserorder-modal-title">Assign Servitor</h2>
//                 <p className="adminUserorder-modal-subtitle">
//                   Order #{assignOrder.order_number} •{" "}
//                   {assignOrder.Service?.services_name}
//                 </p>
//               </div>
//             </div>

//             <div className="adminUserorder-modal-body">
//               <Row className="mb-3">
//                 <Col md={12}>
//                   <Form.Group>
//                     {/* Searchable Mobile dropdown */}
//                     <Row className="mb-3">
//                       <Col md={12}>
//                         <Form.Group>
//                           <Form.Label>
//                             Servitor Mobile (search & select)
//                           </Form.Label>
//                           <Form.Control
//                             list="servitorMobiles"
//                             placeholder="Type to search by mobile / name / city — then pick the mobile"
//                             value={servitorQuery}
//                             onChange={(e) => {
//                               const v = e.target.value;
//                               setServitorQuery(v);
//                               pickServitorByMobile(v);
//                             }}
//                           />
//                           <datalist id="servitorMobiles">
//                             {/* build rich label but the value must be the mobile for selection */}
//                             {servitorList
//                               .filter((r) => {
//                                 const q = servitorQuery.trim().toLowerCase();
//                                 if (!q) return true;
//                                 const hay = [
//                                   r.mobile,
//                                   r.FirstName,
//                                   r.LastName,
//                                   r.city,
//                                   r.area,
//                                   r.Address,
//                                 ]
//                                   .filter(Boolean)
//                                   .join(" ")
//                                   .toLowerCase();
//                                 return hay.includes(q);
//                               })
//                               .slice(0, 50) // keep dropdown concise
//                               .map((r) => (
//                                 <option
//                                   key={r.Id}
//                                   value={r.mobile}
//                                   label={`${r.mobile} — ${r.FirstName || ""} ${
//                                     r.LastName || ""
//                                   } (${r.city || "-"} / ${r.area || "-"})`}
//                                 />
//                               ))}
//                           </datalist>
//                           <div
//                             className="adminUserorder-detail-text"
//                             style={{ marginTop: 6 }}
//                           >
//                             Pick a mobile from the list. We’ll auto-fill the
//                             servitor’s ID and show details below.
//                           </div>
//                         </Form.Group>
//                       </Col>
//                     </Row>

//                     {/* Auto-filled details preview */}
//                     {selectedServitor && (
//                       <Row className="mb-3">
//                         <Col md={12}>
//                           <Card className="adminUserorder-servitor-card">
//                             <div className="adminUserorder-servitor-header">
//                               Selected Servitor
//                             </div>

//                             <div className="adminUserorder-servitor-grid">
//                               <div className="adminUserorder-kv">
//                                 <div className="adminUserorder-kv-label">
//                                   Name
//                                 </div>
//                                 <div className="adminUserorder-kv-value">
//                                   {selectedServitor.FirstName}{" "}
//                                   {selectedServitor.LastName}
//                                 </div>
//                               </div>

//                               <div className="adminUserorder-kv">
//                                 <div className="adminUserorder-kv-label">
//                                   City / Area
//                                 </div>
//                                 <div className="adminUserorder-kv-value">
//                                   {[
//                                     selectedServitor.city,
//                                     selectedServitor.area,
//                                   ]
//                                     .filter(Boolean)
//                                     .join(" / ")}
//                                 </div>
//                               </div>

//                               <div className="adminUserorder-kv">
//                                 <div className="adminUserorder-kv-label">
//                                   Mobile
//                                 </div>
//                                 <div className="adminUserorder-kv-value">
//                                   {selectedServitor.mobile}
//                                 </div>
//                               </div>

//                               <div className="adminUserorder-kv">
//                                 <div className="adminUserorder-kv-label">
//                                   Address
//                                 </div>
//                                 <div className="adminUserorder-kv-value">
//                                   {selectedServitor.Address || "-"}
//                                 </div>
//                               </div>

//                               <div className="adminUserorder-kv">
//                                 <div className="adminUserorder-kv-label">
//                                   ID
//                                 </div>
//                                 <div className="adminUserorder-kv-value">
//                                   {selectedServitor.Id}
//                                 </div>
//                               </div>

//                               <div className="adminUserorder-kv">
//                                 <div className="adminUserorder-kv-label">
//                                   Status / Availability
//                                 </div>
//                                 <div className="adminUserorder-kv-value">
//                                   {selectedServitor.approve_status || "-"} / {selectedServitor.availability || "-"}
//                                 </div>
//                               </div>
//                             </div>
//                           </Card>
//                         </Col>
//                       </Row>
//                     )}

//                     {/* (Optional) Keep manual ID as a fallback/advanced entry */}
//                     <Row className="mb-3">
//                       <Col md={12}>
//                         <Form.Group>
//                           <Form.Label>Servitor ID (auto-filled)</Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Auto-filled after you select a mobile; or override manually"
//                             value={assignForm.servitorId}
//                             readOnly
//                             disabled
//                             title="Auto-filled from servitor selection"

//                             // onChange={(e) => {
//                             //   const v = e.target.value;
//                             //   setAssignForm((f) => ({ ...f, servitorId: v }));
//                             //   // If manual ID doesn't match the selectedServitor, clear the preview & query
//                             //   if (!selectedServitor || String(selectedServitor.Id) !== String(v)) {
//                             //     setSelectedServitor(null);
//                             //     setServitorQuery("");
//                             //   }
//                             // }}
//                           />
//                         </Form.Group>
//                       </Col>
//                     </Row>

//                     <div
//                       className="adminUserorder-detail-text"
//                       style={{ marginTop: 6 }}
//                     >
//                       Tip: paste Servitor Id from the Servitors list, or add a
//                       small search UI later.
//                     </div>
//                   </Form.Group>
//                 </Col>
//               </Row>

//               {assignOrder.Service?.services_name === "Tutor Service" && (
//                 <Row className="mb-3">
//                   <Col md={12}>
//                     <Form.Group>
//                       <Form.Check
//                         type="checkbox"
//                         id="markApproved"
//                         label="Mark tutor as approved (I confirmed with the user over the phone)"
//                         checked={assignForm.markApproved}
//                         onChange={(e) =>
//                           setAssignForm((f) => ({
//                             ...f,
//                             markApproved: e.target.checked,
//                           }))
//                         }
//                       />
//                     </Form.Group>
//                   </Col>
//                 </Row>
//               )}

//               <Row className="mb-3">
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Check
//                       type="checkbox"
//                       id="forceReassign"
//                       label="Force reassign (clear existing servitor & acceptance timestamps)"
//                       checked={assignForm.forceReassign}
//                       onChange={(e) =>
//                         setAssignForm((f) => ({
//                           ...f,
//                           forceReassign: e.target.checked,
//                         }))
//                       }
//                     />
//                     <div
//                       className="adminUserorder-detail-text"
//                       style={{ marginTop: 6 }}
//                     >
//                       Useful if another servitor was set but never started.
//                     </div>
//                   </Form.Group>
//                 </Col>
//               </Row>
//             </div>

//             <div className="adminUserorder-modal-footer">
//               <div className="adminUserorder-footer-buttons">
//                 <button
//                   className="adminUserorder-footer-btn adminUserorder-footer-btn-close"
//                   disabled={assigning || !assignForm.servitorId}
//                   onClick={async () => {
//                     try {
//                       setAssigning(true);
//                       const serviceType =
//                         assignOrder.Service?.services_name || "";
//                       const url = `${URL}/admin/orders/${encodeURIComponent(
//                         serviceType
//                       )}/${encodeURIComponent(
//                         assignOrder.order_number
//                       )}/assign`;

//                       const payload = {
//                         servitorId: Number(assignForm.servitorId),
//                         markApproved: !!assignForm.markApproved,
//                         forceReassign: !!assignForm.forceReassign,
//                       };
//                       const resp = await axios.post(url, payload);
//                       const pin = resp?.data?.order?.verification_pin;
//                       alert(
//                         `Servitor assigned successfully.${
//                           pin
//                             ? `\nPIN (share only with the servitor & user when needed): ${pin}`
//                             : ""
//                         }`
//                       );
//                       await fetchOrders();
//                       closeAssignModal();
//                     } catch (err) {
//                       console.error("Assign servitor failed:", err);
//                       const msg =
//                         err?.response?.data?.message ||
//                         err?.response?.data?.error ||
//                         "Failed to assign servitor";
//                       alert(msg);
//                     } finally {
//                       setAssigning(false);
//                     }
//                   }}
//                 >
//                   {assigning ? (
//                     <Spinner animation="border" size="sm" />
//                   ) : (
//                     <FaCheck />
//                   )}
//                   {assigning ? " Assigning..." : "Assign"}
//                 </button>

//                 <button
//                   className="adminUserorder-footer-btn adminUserorder-footer-btn-print"
//                   onClick={closeAssignModal}
//                   disabled={assigning}
//                 >
//                   <FaTimes /> Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {invoiceOrder && (
//         <ReceiptGenerator
//           order={invoiceOrder}
//           onFinish={() => setInvoiceOrder(null)}
//         />
//       )}

//     </Container>
//   );
// };

// export default UserOrders;







// ***** Update for Protected Auth, upper code is okay (2-Dec-2025) ***** //
import React, { useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import {
  Table,
  Container,
  Card,
  Pagination,
  Badge,
  Button,
  InputGroup,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import { BsEye } from "react-icons/bs";
import {
  FaTimes,
  FaBolt,
  FaUser,
  FaCheckCircle,
  FaDollarSign,
  FaCalendar,
  FaPlusCircle,
  FaWrench,
  FaCogs,
  FaStar,
  FaUserCircle,
  FaPhone,
  FaIdBadge,
  FaMapMarkerAlt,
  FaClock,
  FaPrint,
  FaDownload,
  FaCheck,
  FaEdit,
  // FaTrash,
  FaBroom,
  FaFire,
  FaSnowflake,
  FaFilter as FaFilterIcon,
  FaUserGraduate,
  FaKey,
} from "react-icons/fa";
import "./UserOrderStyle.css";
import { Spinner } from "react-bootstrap";
import { formatDate } from "../../dateTimefrontpart";
import { URL } from "../../../config";
import ReceiptGenerator from "../../User/Profile/ReceiptGenerator";

/* ===========================
   HELPERS — date/time utils
   =========================== */
const pad2 = (n) => String(n).padStart(2, "0");

// normalize date to YYYY-MM-DD
function toDateISO(raw) {
  if (!raw) {
    const d = new Date();
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
  }
  const s = String(raw).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const d = new Date(s);
  if (isNaN(d.getTime())) {
    const n = new Date();
    return `${n.getFullYear()}-${pad2(n.getMonth() + 1)}-${pad2(n.getDate())}`;
  }
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};

// "HH:mm" -> minutes since midnight
function minutesFromHHmm(hhmm) {
  if (!hhmm) return null;
  const m = String(hhmm).match(/^(\d{1,2}):(\d{2})$/);
  if (!m) return null;
  return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
}

// "h:mm AM/PM" -> minutes since midnight
function minutesFromAMPM(s) {
  const m = String(s).match(/^\s*(\d{1,2})[:.](\d{2})\s*([AP]M)\s*$/i);
  if (!m) return null;
  let h = parseInt(m[1], 10);
  const min = parseInt(m[2], 10);
  const ampm = m[3].toUpperCase();
  if (ampm === "PM" && h < 12) h += 12;
  if (ampm === "AM" && h === 12) h = 0;
  return h * 60 + min;
}

// accepts "HH:mm" or "h:mm AM/PM" and returns minutes
function minutesFromAnyTime(t) {
  if (!t) return null;
  const s = String(t).trim();
  const hhmm = s.match(/^\d{1,2}:\d{2}$/);
  if (hhmm) return minutesFromHHmm(s);
  return minutesFromAMPM(s);
}

function toAMPMFromMinutes(mins) {
  if (mins == null) return "";
  let h = Math.floor(mins / 60);
  const m = mins % 60;
  const am = h < 12;
  let displayHour = h % 12;
  if (displayHour === 0) displayHour = 12;
  return `${displayHour}:${pad2(m)} ${am ? "AM" : "PM"}`;
}

// for display everywhere
function formatTimeDisplay(raw) {
  const mins = minutesFromAnyTime(raw);
  if (mins == null) return String(raw ?? "");
  return toAMPMFromMinutes(mins);
}

// For deadline
function formatDeadlineTime(raw) {
  if (!raw) return "-";
  const d = new Date(raw);
  if (isNaN(d.getTime())) return String(raw);
  return toAMPMFromMinutes(d.getHours() * 60 + d.getMinutes());
}

// compute min date/time (cannot go earlier than current schedule; also not earlier than today)
function getMinLimitsForOrder(order, { ignoreExisting = false } = {}) {
  const schedDateISO = toDateISO(order?.date);
  const schedTimeMins = minutesFromAnyTime(order?.time); // handles "16:30" or "4:30 PM"
  const now = new Date();
  const nowDateISO = todayISO();
  const nowMins = now.getHours() * 60 + now.getMinutes();

  // min date is the later of today vs scheduled date
  const minDateISO = ignoreExisting
    ? nowDateISO
    : schedDateISO >= nowDateISO
    ? schedDateISO
    : nowDateISO;

  // min time depends on chosen date
  function computeMinTimeMins(newDateISO) {
    if (!newDateISO) return null;
    if (!ignoreExisting) {
      if (newDateISO === schedDateISO && schedDateISO >= nowDateISO) {
        return schedTimeMins ?? null;
      }
    }
    if (newDateISO === nowDateISO) {
      return nowMins;
    }
    return null;
  }
  return { minDateISO, computeMinTimeMins };
}

// generate 30-min slots (7:00–21:00), excluding slots < min on chosen day, and past slots today
function generateSlotsAMPM(dateISO, minDateISO, minTimeMinsForThisDate) {
  const slots = [];
  if (!dateISO) return slots;

  const startHour = 7;
  const endHour = 21; // inclusive hour for last slot start (21:00)

  const now = new Date();
  const today = todayISO();
  const isToday = dateISO === today;

  const baseMin = minTimeMinsForThisDate ?? null; // boundary for this selected date

  for (let h = startHour; h <= endHour; h++) {
    for (let m = 0; m < 60; m += 30) {
      const mins = h * 60 + m;

      // block if selected date is before minDate
      if (dateISO < minDateISO) continue;

      // block if it's today and slot <= now
      if (isToday) {
        const nowMins = now.getHours() * 60 + now.getMinutes();
        if (mins <= nowMins) continue;
      }

      // block if earlier than minimum boundary (previous schedule)
      if (baseMin != null && mins < baseMin) continue;

      slots.push(toAMPMFromMinutes(mins));
    }
  }
  return slots;
}

// custome service order helper
// Custom services helper (supports backend parsed customServices OR parses custom_service_json)
const getCustomItems = (order) => {
  if (Array.isArray(order?.customServices)) return order.customServices;

  const raw = order?.custom_service_json;
  if (!raw) return [];

  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

/* ===========================
   ADMIN AUTH HELPER
   =========================== */
const getAdminHeaders = () => {
  const adminToken = localStorage.getItem("adminToken");
  return adminToken ? { Authorization: `Bearer ${adminToken}` } : {};
};
/* =========================== */

const UserOrders = () => {
  // Table (server-driven) data
  const [orders, setOrders] = useState([]);
  const [meta, setMeta] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
    sortBy: "created_at",
    sortDir: "DESC",
    serviceType: "All",
    status: "",
    search: "",
  });

  // UI state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Filters
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("All");
  const [filterStatus, setFilterStatus] = useState("All");

  // Detail modal
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const modalRef = useRef(null);

  // Edit schedule modal
  const [showEdit, setShowEdit] = useState(false);
  const [editOrder, setEditOrder] = useState(null);
  const [saving, setSaving] = useState(false);
  const editModalRef = useRef(null);

  // Servitor lookup state for Assign modal
  const [servitorList, setServitorList] = useState([]); // the fetched rows
  const [servitorQuery, setServitorQuery] = useState(""); // what admin types into the search
  const [selectedServitor, setSelectedServitor] = useState(null); // chosen row

  // Servitor Assign modal
  const [showAssign, setShowAssign] = useState(false);
  const [assignOrder, setAssignOrder] = useState(null);
  const [assignForm, setAssignForm] = useState({
    servitorId: "",
    markApproved: false, // only relevant for Tutor Service
    forceReassign: false, // allow reassign if admin wants to override
  });
  const [assigning, setAssigning] = useState(false);

  const [invoiceOrder, setInvoiceOrder] = useState(null);

  const openAssignModal = async (order) => {
    setAssignOrder(order);
    setAssignForm({
      servitorId: "",
      markApproved: false,
      forceReassign: false,
    });
    setServitorList([]);
    setServitorQuery("");
    setSelectedServitor(null);
    setShowAssign(true);
    document.body.style.overflow = "hidden";

    // Fetch list filtered by this order's service
    try {
      const svc = order?.Service?.services_name || "";
      const { data } = await axios.get(`${URL}/admin/servitors`, {
        params: { serviceType: svc, limit: 300 },
        headers: getAdminHeaders(),
      });
      setServitorList(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("Failed to load servitors for assign:", e);
    }
  };

  const closeAssignModal = () => {
    setShowAssign(false);
    setAssignOrder(null);
    document.body.style.overflow = "auto";
  };

  const pickServitorByMobile = (mobile) => {
    const s = servitorList.find((r) => String(r.mobile) === String(mobile));
    if (s) {
      setSelectedServitor(s);
      setAssignForm((f) => ({ ...f, servitorId: s.Id })); // lock correct Id
    } else {
      setSelectedServitor(null);
      setAssignForm((f) => ({ ...f, servitorId: "" }));
    }
  };

  const [editForm, setEditForm] = useState({
    newDate: "", // YYYY-MM-DD
    newSlot: "", // "h:mm AM/PM"
    keepServitor: false,
    reason: "",
    reorder: false,
  });

  const forceKeepStatuses = [
    "Accepted",
    "In-Progress",
    "Cancelled by Servitor",
  ];

  const fetchOrders = async () => {
    try {
      const params = new URLSearchParams({
        page: currentPage,
        limit: itemsPerPage,
        search: searchTerm || "",
        status: filterStatus === "All" ? "" : filterStatus,
        serviceType: filterType === "All" ? "" : filterType,
        sortBy: "created_at",
        sortDir: "DESC",
      }).toString();

      const { data } = await axios.get(`${URL}/all-user-orders?${params}`, {
        headers: getAdminHeaders(),
      });
      const { data: rows = [], meta: m = {} } = data || {};
      setOrders(rows);
      setMeta({
        page: m.page || 1,
        limit: m.limit || itemsPerPage,
        total: m.total || 0,
        totalPages: Math.max(1, m.totalPages || 1),
        sortBy: m.sortBy || "created_at",
        sortDir: m.sortDir || "DESC",
        serviceType: m.serviceType || "All",
        status: m.status || "",
        search: m.search || "",
      });
    } catch (err) {
      // 404 => no data; other errors => log
      if (err?.response?.status === 404) {
        setOrders([]);
        setMeta((prev) => ({ ...prev, total: 0, totalPages: 1 }));
      } else {
        console.error("Error fetching orders:", err);
      }
    }
  };

  // Fetch on mount + on any filter/page change
  useEffect(() => {
    fetchOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, searchTerm, filterType, filterStatus]);

  // ===== Details modal =====
  const handleViewDetails = (order) => {
    setSelectedOrder(order);
    setShowModal(true);
    document.body.style.overflow = "hidden";
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    const node = modalRef.current;
    const handleBackdropClick = (e) => {
      if (node && e.target === node) {
        handleCloseModal();
      }
    };
    const handleEscapeKey = (e) => {
      if (e.key === "Escape") {
        handleCloseModal();
      }
    };
    if (node) node.addEventListener("click", handleBackdropClick);
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      if (node) node.removeEventListener("click", handleBackdropClick);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, []);

  // ===== Edit schedule modal =====
  const handleCloseEdit = () => {
    setShowEdit(false);
    setEditOrder(null);
    setSaving(false);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    const node = editModalRef.current;
    const handleBackdropClick = (e) => {
      if (node && e.target === node) handleCloseEdit();
    };
    const handleEscapeKey = (e) => {
      if (e.key === "Escape") handleCloseEdit();
    };
    if (node) node.addEventListener("click", handleBackdropClick);
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      if (node) node.removeEventListener("click", handleBackdropClick);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, []);

  const handleEditOrder = (order) => {
    if (!order) return;
    const st = String(order.status || "").toLowerCase();
    if (st === "in-progress") {
      alert("In-Progress orders cannot be rescheduled.");
      return;
    }
    if (st === "completed") {
      alert("Completed orders cannot be rescheduled.");
      return;
    }

    setEditOrder(order);

    const dISO = toDateISO(order.date);
    const timeAMPM = formatTimeDisplay(order.time);
    const forceKeep = forceKeepStatuses.includes(order.status);

    setEditForm({
      newDate: dISO,
      newSlot: timeAMPM,
      keepServitor: forceKeep,
      reason: "",
      reorder: false,
    });

    setShowEdit(true);
    document.body.style.overflow = "hidden";
  };

  // const handleDeleteOrder = (order) => {
  //   console.log("Deleting order:", order);
  //   // (optional) implement delete functionality here if you add a backend endpoint
  // };

  // recompute slot list when date/order changes
  const slotData = useMemo(() => {
    if (!editOrder)
      return { slots: [], minDateISO: todayISO(), minTimeInfo: null };
    const { minDateISO, computeMinTimeMins } = getMinLimitsForOrder(editOrder, {
      ignoreExisting: !!editForm.reorder,
    });
    const minMins = computeMinTimeMins(editForm.newDate);
    const slots = generateSlotsAMPM(editForm.newDate, minDateISO, minMins);

    // ensure selected slot is valid; if not, pick first available
    let selected = editForm.newSlot;
    const found = slots.includes(selected);
    if (!found && slots.length > 0) {
      selected = slots[0];
      setEditForm((f) => ({ ...f, newSlot: selected }));
    }
    return {
      slots,
      minDateISO,
      minTimeInfo:
        minMins != null
          ? `Earliest allowed this day: ${toAMPMFromMinutes(minMins)}`
          : null,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editOrder, editForm.newDate]);

  const submitEdit = async () => {
    if (!editOrder) return;

    const st = String(editOrder.status || "").toLowerCase();
    if (st === "in-progress" || st === "completed") {
      alert("This order cannot be rescheduled.");
      return;
    }

    if (!editForm.newDate || !editForm.newSlot) {
      alert("Please select both a date and a time slot.");
      return;
    }

    const serviceType = editOrder?.Service?.services_name || "";
    const url = `${URL}/admin/orders/${encodeURIComponent(serviceType)}/${
      editOrder.Id
    }/reschedule`;

    // Validate date/time against min limits
    const { minDateISO, computeMinTimeMins } = getMinLimitsForOrder(editOrder, {
      ignoreExisting: !!editForm.reorder,
    });
    if (editForm.newDate < minDateISO) {
      alert("New date cannot be earlier than the current schedule/today.");
      return;
    }
    const slotMins = minutesFromAMPM(editForm.newSlot);
    const minMins = computeMinTimeMins(editForm.newDate);
    if (minMins != null && slotMins < minMins) {
      alert(`New time cannot be earlier than ${toAMPMFromMinutes(minMins)}.`);
      return;
    }

    const payload = {
      keepServitor: editForm.keepServitor,
      reason: editForm.reason?.trim() || undefined,
      reorder: !!editForm.reorder,
      newDate: editForm.newDate,
      newTime: editForm.newSlot, // backend accepts AM/PM
    };

    try {
      setSaving(true);
      const resp = await axios.post(url, payload, {
        headers: getAdminHeaders(),
      });
      alert(resp?.data?.message || "Order rescheduled");
      // Refresh current page to keep server-driven list accurate
      await fetchOrders();
      handleCloseEdit();
    } catch (err) {
      console.error("Reschedule failed:", err);
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Failed to reschedule";
      alert(msg);
    } finally {
      setSaving(false);
    }
  };

  // Pagination helpers
  const indexOfFirstItem = (meta.page - 1) * meta.limit;
  const totalPages = meta.totalPages || 1;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getPageItems = (total, current, maxButtons = 7) => {
    const pages = [];
    pages.push(1);
    const siblings = Math.floor((maxButtons - 3) / 2);
    let start = Math.max(2, current - siblings);
    let end = Math.min(total - 1, current + siblings);
    if (current <= siblings + 2) {
      end = Math.min(total - 1, maxButtons - 1);
    }
    if (current >= total - (siblings + 1)) {
      start = Math.max(2, total - (maxButtons - 2));
    }
    if (start > 2) pages.push("start-ellipsis");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < total - 1) pages.push("end-ellipsis");
    if (total > 1) pages.push(total);
    return pages;
  };

  const handlePrintReceipt = () => {
    console.log("Printing order receipt...");
  };

  const handleDownloadInvoice = () => {
    if (!selectedOrder) {
      alert("Open an order first to download its invoice.");
      return;
    }
    setInvoiceOrder(selectedOrder);
  };

  // build an ordered list of timeline steps
  const buildTimeline = (order) => {
    const steps = [];
    steps.push({
      key: "placed",
      label: "Order Placed",
      time: order.created_at,
      dotClass: "completed",
    });
    if (order.accepted_at) {
      steps.push({
        key: "accepted",
        label: "Order Accepted",
        time: order.accepted_at,
        dotClass:
          order.status === "Accepted" ||
          order.status === "In-Progress" ||
          order.status === "Completed"
            ? "completed"
            : "inactive",
      });
    }
    if (order.in_progress_at) {
      steps.push({
        key: "in_progress",
        label: "Service In Progress",
        time: order.in_progress_at,
        dotClass:
          order.status === "In-Progress" || order.status === "Completed"
            ? "in-progress"
            : "inactive",
      });
    }
    if (order.completed_at) {
      steps.push({
        key: "completed",
        label: "Order Completed",
        time: order.completed_at,
        dotClass: "arrived",
      });
    }
    if (order.status && String(order.status).toLowerCase().includes("cancel")) {
      steps.push({
        key: "cancelled",
        label: `Order ${order.status}`,
        time: order.updated_at,
        dotClass: "cancelled",
      });
    }
    return steps;
  };

  const renderOrderDetails = () => {
    if (!selectedOrder) return null;

    const type = selectedOrder.service_name;
    let icon = <FaBolt />;

    // Build service-specific detail blocks
    let details = {};
    if (type === "Electrician") {
      details = {
        Installation: {
          "New Ceiling Fan Installation":
            selectedOrder.new_ceiling_fan_installation,
          "Ceiling Fan Installation": selectedOrder.ceiling_fan_installation,
          "Ceiling Fan Uninstallation":
            selectedOrder.ceiling_fan_uninstallation,
          "Light Installation": selectedOrder.light_installation,
          "Exhaust Fan Installation": selectedOrder.exhaust_fan_installation,
          "Doorbell Installation": selectedOrder.doorbell_installation,
          "Switch Setup": selectedOrder.switch_setup,
          "Socket Setup": selectedOrder.socket_setup,
          "Regulator Setup": selectedOrder.regulator_setup,
          "IPS Installation (Existing Line)":
            selectedOrder.ips_installation_existing_line,
          "IPS New Line Installation": selectedOrder.ips_new_line_installation,
        },
        Repair: {
          "Fan Coil Repair": selectedOrder.fan_coil_repair,
          "Light Repair": selectedOrder.light_repair,
        },
        Maintenance: {
          "Fan Coil New Winding": selectedOrder.fan_coil_new_winding,
          "Capacitor Setup": selectedOrder.capacitor_setup,
          "Exhaust Fan Cleaning": selectedOrder.exhaust_fan_cleaning,
          "Main Circuit Board Setup": selectedOrder.main_circuit_board_setup,
        },
        Additional: {
          "New Wiring Point": selectedOrder.new_wiring_point,
          "Drill Hole Service": selectedOrder.drill_hole_service,
          "Electrical Checkup": selectedOrder.Electrical_checkup ? "Yes" : "No",
        },
      };
      icon = <FaBolt />;
    } else if (type === "Home Cleaning") {
      details = {
        "Room Cleaning": {
          "Bed Cleaning": selectedOrder.bed,
          "Bathroom Cleaning": selectedOrder.bath,
          "Drawing/Dining Cleaning": selectedOrder.dra_din,
          "Balcony Cleaning": selectedOrder.balcony,
          "Kitchen Cleaning": selectedOrder.kitchen,
          "Satirs & Railing Cleaning": selectedOrder.stairs_and_railing,
        },
        "Additional Cleaning": {
          "Window & Grill Cleaning": selectedOrder.window_grill,
          "Furniture Cleaning": selectedOrder.furniture_cleaning,
          "Cloth Washing": selectedOrder.cloth,
          "Dish Washing": selectedOrder.dish,
          "Carpet Cleaning": selectedOrder.carpet_cleaning,
        },
      };
      icon = <FaBroom />;
    } else if (type === "Plumber") {
      details = {
        Installation: {
          "Angle Valve Setup": selectedOrder.angle_valve_setup,
          "Basin Tap (Faucet) Setup": selectedOrder.basin_tap_setup,
          "Magic Pipe (Flexible Drain) Setup": selectedOrder.magic_pipe_setup,
          "Basin Waste / Pop-Up Setup": selectedOrder.basin_waste_pop_up_setup,
          "New Basin Setup (existing lines)":
            selectedOrder.new_basin_setup_existing_lines,
          "Bathroom Tap Setup": selectedOrder.bathroom_tap_bib_cock_setup,
          "Tissue Holder Setup": selectedOrder.tissue_holder_setup,
          "Hand Shower Setup": selectedOrder.hand_shower_setup,
          "Soap Dish Setup": selectedOrder.soap_dish_setup,
          "Bathroom Shelf Setup": selectedOrder.bathroom_shelf_setup,
          "Looking Glass/Mirror Setup": selectedOrder.mirror_setup,
          "Towel Hanger / Ring Setup": selectedOrder.towel_hanger_setup,
          "Shower Head + Hose Setup": selectedOrder.shower_head_setup,
          "Concealed Stopcock Valve Setup":
            selectedOrder.concealed_stopcock_setup,
          "Floor Drain Net Setup": selectedOrder.floor_drain_net_setup,
          "Toilet Seat Complete Installation":
            selectedOrder.toilet_seat_complete_installation,
          "High Commode Installation (existing lines)":
            selectedOrder.high_commode_installation_existing_lines,
          "Kitchen Sink Setup (existing lines)":
            selectedOrder.kitchen_sink_setup_existing_lines,
          "Geyser Installation": selectedOrder.geyser_installation,
          "Washing Machine Point Setup (existing Line)":
            selectedOrder.washing_machine_point_setup,
        },
        Repair: {
          "Toilet Seat Cover Replacement":
            selectedOrder.toilet_seat_cover_replacement,
          "Fill Valve Replacement (High Commode)":
            selectedOrder.fill_valve_replacement,
          "Blockage Clearing — High Commode":
            selectedOrder.blockage_clearing_high_commode,
          "Blockage Clearing — Low Commode":
            selectedOrder.blockage_clearing_low_commode,
        },
        Maintenance: {
          "Bathroom Drain Line Cleaning (per bathroom)":
            selectedOrder.bathroom_drain_line_cleaning,
          "Sink Blockage Cleaning": selectedOrder.sink_blockage_cleaning,
        },
        Additional: {
          "Plumbing Checkup / Diagnosis": selectedOrder.issue_checkup
            ? "Yes"
            : "No",
        },
      };
      icon = <FaCogs />;
    } else if (type === "Gas Chula") {
      details = {
        Installation: {
          "Cylinder Type": selectedOrder.chulaCylinderType,
          "New Chula Setup": selectedOrder.NewchulaSetup,
          "Chula Setup": selectedOrder.chulaSetup,
          "Burner Setup": selectedOrder.burnerSetup,
        },
        Maintenance: {
          "Burner Cleaning": selectedOrder.burnerCleaning,
          "Nozzle Replacement": selectedOrder.nozzleReplacement,
          "Check Issues": selectedOrder.checkIssues ? "Yes" : "No",
        },
      };
      icon = <FaFire />;
    } else if (type === "AC Service") {
      const n = (v) => (v == null || isNaN(Number(v)) ? 0 : Number(v));
      details = {
        Specifications: {
          "AC Type": selectedOrder.acType || "-",
          "AC Ton": selectedOrder.acTon || "-",
        },
        Installation: {
          "AC Install (Outdoor Unit Inside)": n(
            selectedOrder.installation_outdoor_inside
          ),
          "AC Install (Outdoor Unit Outside)": n(
            selectedOrder.installation_outdoor_outside
          ),
        },
        Uninstallation: {
          "AC Uninstall (Outdoor Unit Inside)": n(
            selectedOrder.uninstallation_outdoor_inside
          ),
          "AC Uninstall (Outdoor Unit Outside)": n(
            selectedOrder.uninstallation_outdoor_outside
          ),
        },
        Maintenance: {
          "AC Cleaning (Outdoor Unit Inside)": n(
            selectedOrder.cleaning_outdoor_inside
          ),
          "AC Cleaning (Outdoor Unit Outside)": n(
            selectedOrder.cleaning_outdoor_outside
          ),
          "Issue Checkup (units)": n(selectedOrder.issue_checkup),
        },
      };
      icon = <FaSnowflake />;
    } else if (type === "Filter") {
      details = {
        Specifications: {
          "Filter Type": selectedOrder.filter_type || "-",
        },
        Additional: {
          "Issue Checkup": selectedOrder.check_up ? "Yes" : "No",
        },
        Installation: {
          "New Filter Setup": selectedOrder.new_filter_setup,
          "Filter Installation": selectedOrder.installation_filter,
          "Filter Uninstallation": selectedOrder.uninstallation_filter,
        },
        Maintenance: {
          "Kit Replacement": selectedOrder.kit_replacement,
          "Pipe Leak / Replace": selectedOrder.pipe_leak_or_replace,
          "Full Servicing": selectedOrder.full_servicing,
        },
      };
      icon = <FaFilterIcon />;
    } else if (type === "Tutor Service") {
      const clean = (v) =>
        v !== undefined &&
        v !== null &&
        String(v).trim() !== "" &&
        String(v).trim().toLowerCase() !== "any";

      const core = {};
      if (clean(selectedOrder.subject)) core["Subject"] = selectedOrder.subject;
      if (clean(selectedOrder.classLevel))
        core["Class/Level"] = selectedOrder.classLevel;
      if (clean(selectedOrder.medium)) core["Medium"] = selectedOrder.medium;

      const schedule = {};
      if (clean(selectedOrder.daysPerWeek))
        schedule["Days per Week"] = `${selectedOrder.daysPerWeek}`;
      if (clean(selectedOrder.hoursPerDay))
        schedule["Hours per Day"] = `${selectedOrder.hoursPerDay}`;
      if (clean(selectedOrder.salary))
        schedule["Salary"] = `৳${selectedOrder.salary}`;

      const prefs = {};
      if (clean(selectedOrder.preferredTutorGender))
        prefs["Preferred Tutor Gender"] = selectedOrder.preferredTutorGender;
      if (clean(selectedOrder.priorityInstitution))
        prefs["Priority Institution"] = selectedOrder.priorityInstitution;

      details = {};
      if (Object.keys(core).length) details["Tutoring"] = core;
      if (Object.keys(schedule).length) details["Schedule & Budget"] = schedule;
      if (Object.keys(prefs).length) details["Preferences"] = prefs;

      icon = <FaUserGraduate />;
    }

    // remarks + custom services (after details built, before return)
    const remarkText = String(selectedOrder?.remarks || "").trim();

    const customItems = getCustomItems(selectedOrder).filter((c) => {
      const name = String(c?.name || "").trim();
      const price = Number(c?.price || 0);
      return name && Number.isFinite(price) && price > 0;
    });

    const customTotal = customItems.reduce((sum, c) => sum + Number(c.price || 0), 0);

    return (
      <div className="adminUserorder-modal">
        {/* Modal Header */}
        <div className="adminUserorder-modal-header">
          <button
            className="adminUserorder-modal-close"
            onClick={handleCloseModal}
          >
            <FaTimes size={20} />
          </button>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <div className="adminUserorder-service-icon">{icon}</div>
            <div>
              <h2 className="adminUserorder-modal-title">Order Details</h2>
              <p className="adminUserorder-modal-subtitle">
                Order #{selectedOrder.order_number} • {type} Service • Order Id: {selectedOrder.Id}
              </p>
            </div>
          </div>
        </div>

        {/* Modal Body */}
        <div className="adminUserorder-modal-body">
          {/* Summary Cards */}
          <div className="adminUserorder-summary-cards">
            <div className="adminUserorder-summary-card adminUserorder-status-card">
              <div>
                <p className="adminUserorder-detail-text">Status</p>
                <span
                  className={`adminUserorder-badge-${selectedOrder.status
                    .toLowerCase()
                    .replace(" ", "-")}`}
                >
                  {selectedOrder.status}
                </span>
              </div>
              <FaCheckCircle size={24} style={{ color: "#22c55e" }} />
            </div>

            <div className="adminUserorder-summary-card adminUserorder-price-card">
              <div>
                <p className="adminUserorder-detail-text">Total Amount</p>
                <p className="adminUserorder-price-value">
                  ৳{selectedOrder.price}
                </p>
              </div>
              <FaDollarSign size={24} style={{ color: "#2563eb" }} />
            </div>

            <div className="adminUserorder-summary-card adminUserorder-date-card">
              <div>
                <p className="adminUserorder-detail-text">Service Date</p>
                <p className="adminUserorder-date-value">
                  {selectedOrder.date}
                </p>
                <p className="adminUserorder-time-value">
                  {selectedOrder.time}
                </p>
              </div>
              <FaCalendar size={24} style={{ color: "#7c3aed" }} />
            </div>
          </div>

          {/* Customer Information */}
          <div className="adminUserorder-detail-card">
            <h3 className="adminUserorder-detail-title">
              <FaUser
                style={{ marginRight: "8px", color: "var(--primary-color)" }}
              />
              Customer Information
            </h3>
            <div className="adminUserorder-customer-grid">
              <div>
                <div className="adminUserorder-customer-info">
                  <FaUserCircle className="adminUserorder-customer-icon" />
                  <div>
                    <p className="adminUserorder-detail-text">Customer Name</p>
                    <p className="adminUserorder-detail-value">
                      {selectedOrder.User?.FirstName}{" "}
                      {selectedOrder.User?.LastName}
                    </p>
                  </div>
                </div>
                <div className="adminUserorder-customer-info">
                  <FaPhone className="adminUserorder-customer-icon" />
                  <div>
                    <p className="adminUserorder-detail-text">Mobile Number</p>
                    <p className="adminUserorder-detail-value">
                      {selectedOrder.User?.mobile}
                    </p>
                  </div>
                </div>

                {/* This one is only for Temporary for manual order */}
                <div className="adminUserorder-customer-info">
                  <FaKey className="adminUserorder-customer-icon" />
                  <div>
                    <p className="adminUserorder-detail-text">
                      Verification Code
                    </p>
                    <p className="adminUserorder-detail-value">
                      {selectedOrder.verification_pin}
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <div className="adminUserorder-customer-info">
                  <FaIdBadge className="adminUserorder-customer-icon" />
                  <div>
                    <p className="adminUserorder-detail-text">User ID</p>
                    <p className="adminUserorder-detail-value">
                      {selectedOrder.User?.Id}
                    </p>
                  </div>
                </div>
                <div className="adminUserorder-customer-info">
                  <FaMapMarkerAlt className="adminUserorder-customer-icon" />
                  <div>
                    <p className="adminUserorder-detail-text">
                      Service Location
                    </p>
                    <p className="adminUserorder-detail-value">
                      {[
                        selectedOrder.City,
                        selectedOrder.Area,
                        selectedOrder.Address,
                      ]
                        .filter(Boolean)
                        .join(" - ")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {["Accepted", "Completed", "Cancelled by Servitor"].includes(
            selectedOrder.status
          ) && (
            <div className="adminUserorder-detail-card">
              <h3 className="adminUserorder-detail-title">
                <FaUser
                  style={{ marginRight: "8px", color: "var(--primary-color)" }}
                />
                Servitor Information
              </h3>
              <div className="adminUserorder-customer-grid">
                <div>
                  <div className="adminUserorder-customer-info">
                    <FaUserCircle className="adminUserorder-customer-icon" />
                    <div>
                      <p className="adminUserorder-detail-text">
                        Servitor Name
                      </p>
                      <p className="adminUserorder-detail-value">
                        {selectedOrder.Servitor?.FirstName}{" "}
                        {selectedOrder.Servitor?.LastName}
                      </p>
                    </div>
                  </div>
                  <div className="adminUserorder-customer-info">
                    <FaPhone className="adminUserorder-customer-icon" />
                    <div>
                      <p className="adminUserorder-detail-text">
                        Mobile Number
                      </p>
                      <p className="adminUserorder-detail-value">
                        {selectedOrder.Servitor?.mobile}
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="adminUserorder-customer-info">
                    <FaIdBadge className="adminUserorder-customer-icon" />
                    <div>
                      <p className="adminUserorder-detail-text">NID</p>
                      <p className="adminUserorder-detail-value">
                        {selectedOrder.Servitor?.NID}
                      </p>
                    </div>
                  </div>
                  <div className="adminUserorder-customer-info">
                    <FaMapMarkerAlt className="adminUserorder-customer-icon" />
                    <div>
                      <p className="adminUserorder-detail-text">Address</p>
                      <p className="adminUserorder-detail-value">
                        {[
                          selectedOrder.Servitor?.city,
                          selectedOrder.Servitor?.area,
                          selectedOrder.Servitor?.Address,
                        ]
                          .filter(Boolean)
                          .join(" - ")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Service Details */}
          <div className="adminUserorder-detail-card">
            <h3 className="adminUserorder-detail-title">
              {type} Service Details
            </h3>
            <div className="adminUserorder-service-grid">
              {Object.entries(details).map(([category, items]) => (
                <div key={category} className="adminUserorder-service-category">
                  <h4 className="adminUserorder-category-title">
                    {category === "Installation" && (
                      <FaPlusCircle
                        style={{ marginRight: "8px", color: "#22c55e" }}
                      />
                    )}
                    {category === "Repair" && (
                      <FaWrench
                        style={{ marginRight: "8px", color: "#f59e0b" }}
                      />
                    )}
                    {category === "Maintenance" && (
                      <FaCogs
                        style={{ marginRight: "8px", color: "#3b82f6" }}
                      />
                    )}
                    {category === "Additional" && (
                      <FaStar
                        style={{ marginRight: "8px", color: "#7c3aed" }}
                      />
                    )}
                    {category === "Room Cleaning" && (
                      <FaBroom
                        style={{ marginRight: "8px", color: "#10b981" }}
                      />
                    )}
                    {category === "Additional Cleaning" && (
                      <FaStar
                        style={{ marginRight: "8px", color: "#7c3aed" }}
                      />
                    )}
                    {category === "Specifications" && (
                      <FaSnowflake
                        style={{ marginRight: "8px", color: "#7c3aed" }}
                      />
                    )}
                    {category === "Tutoring" && (
                      <FaUserGraduate
                        style={{ marginRight: "8px", color: "#2563eb" }}
                      />
                    )}
                    {category === "Schedule & Budget" && (
                      <FaCalendar
                        style={{ marginRight: "8px", color: "#7c3aed" }}
                      />
                    )}
                    {category === "Preferences" && (
                      <FaStar
                        style={{ marginRight: "8px", color: "#f59e0b" }}
                      />
                    )}
                    {category}
                  </h4>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    {Object.entries(items).map(([key, value]) => (
                      <div
                        key={key}
                        className={`adminUserorder-service-item ${
                          value === 0 || value === "No" ? "inactive" : ""
                        }`}
                      >
                        <span
                          className={`adminUserorder-service-name ${
                            value === 0 || value === "No" ? "inactive" : ""
                          }`}
                        >
                          {key}
                        </span>
                        <span
                          className={`adminUserorder-service-value${
                            value === 0 || value === "No" ? "-inactive" : ""
                          }`}
                        >
                          {value}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {customItems.length > 0 && (
          <div className="adminUserorder-detail-card">
            <h3 className="adminUserorder-detail-title">
              <FaStar style={{ marginRight: 8, color: "#f59e0b" }} />
              Custom Services
            </h3>

            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {customItems.map((c, idx) => (
                <div key={idx} className="adminUserorder-service-item">
                  <span className="adminUserorder-service-name">
                    {idx + 1}. {String(c.name).trim()}
                  </span>
                  <span className="adminUserorder-service-value">
                    ৳{Number(c.price).toLocaleString("en-BD")}
                  </span>
                </div>
              ))}

              <div style={{ marginTop: 10, borderTop: "1px dashed #cbd5e1", paddingTop: 10 }}>
                <div className="adminUserorder-service-item">
                  <span className="adminUserorder-service-name" style={{ fontWeight: 700 }}>
                    Custom Total
                  </span>
                  <span className="adminUserorder-service-value" style={{ fontWeight: 700 }}>
                    ৳{customTotal.toLocaleString("en-BD")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}



          {remarkText && (
            <div className="adminUserorder-detail-card">
              <h3 className="adminUserorder-detail-title">
                <FaEdit style={{ marginRight: 8, color: "var(--primary-color)" }} />
                Remarks / Notes
              </h3>

              <div
                className="adminUserorder-detail-value"
                style={{
                  whiteSpace: "pre-wrap",
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  borderRadius: 10,
                  padding: 12,
                  lineHeight: 1.5,
                }}
              >
                {remarkText}
              </div>
            </div>
          )}


          <div className="adminUserorder-detail-card">
            <h3 className="adminUserorder-detail-title">
              <FaClock
                style={{ marginRight: "8px", color: "var(--primary-color)" }}
              />
              Order Timeline
            </h3>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "16px" }}
            >
              {buildTimeline(selectedOrder).map((step) => (
                <div key={step.key} className="adminUserorder-timeline-item">
                  {step.key === "cancelled" ? (
                    <FaTimes
                      size={16}
                      className="adminUserorder-timeline-cancel-icon"
                    />
                  ) : (
                    <div
                      className={`adminUserorder-timeline-dot ${step.dotClass}`}
                    ></div>
                  )}
                  <div className="adminUserorder-timeline-content">
                    <h4>{step.label}</h4>
                    <p>{new Date(step.time).toLocaleString()}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {selectedOrder.customerFeedback != null && (
            <div className="adminUserorder-detail-card">
              <h3 className="adminUserorder-detail-title">
                <FaStar style={{ marginRight: 8, color: "#f59e0b" }} />
                Customer Feedback
              </h3>
              <p className="adminUserorder-detail-value">
                {selectedOrder.customerFeedback}
              </p>
            </div>
          )}

          {(() => {
            const fb = selectedOrder?.cancellation_feedback;
            const hasFeedback =
              typeof fb === "string" ? fb.trim().length > 0 : !!fb;

            return (
              hasFeedback && (
                <div className="adminUserorder-detail-card">
                  <h3 className="adminUserorder-detail-title">
                    <FaTimes
                      style={{ marginRight: "8px", color: "#ef4444" }}
                    />
                    Cancellation Feedback
                  </h3>
                  <p className="adminUserorder-detail-value">{fb}</p>
                </div>
              )
            );
          })()}
        </div>

        {/* Modal Footer */}
        <div className="adminUserorder-modal-footer">
          <div className="adminUserorder-footer-buttons">
            <button
              className="adminUserorder-footer-btn adminUserorder-footer-btn-print"
              onClick={handlePrintReceipt}
            >
              <FaPrint />
              Print Receipt
            </button>
            <button
              className="adminUserorder-footer-btn adminUserorder-footer-btn-download"
              onClick={handleDownloadInvoice}
            >
              <FaDownload />
              Download Invoice
            </button>
            <button
              className="adminUserorder-footer-btn adminUserorder-footer-btn-close"
              onClick={handleCloseModal}
            >
              <FaCheck />
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container fluid className="adminUserorder-container">
      <Card className="adminUserorder-card">
        <Card.Body>
          <Card.Header className="adminUserorder-header">
            <h4 className="adminUserorder-title">All User Orders</h4>
          </Card.Header>

          <Row className="mb-3">
            <Col md={8}>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search by Order Number, User ID or Mobile Number"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1); // reset page when searching
                  }}
                  className="adminUserorder-search"
                />
              </InputGroup>
            </Col>
            <Col md={4}>
              <Form.Group controlId="statusFilter">
                <Form.Select
                  value={filterStatus}
                  onChange={(e) => {
                    setFilterStatus(e.target.value);
                    setCurrentPage(1); // reset page on filter change
                  }}
                  className="adminUserorder-filter-select"
                >
                  <option value="All">All Statuses</option>
                  <option value="Pending">Pending</option>
                  <option value="Accepted">Accepted</option>
                  <option value="In-Progress">In-Progress</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Cancelled by Servitor">
                    Cancelled by Servitor
                  </option>
                  <option value="Completed">Completed</option>
                  <option value="Deadline-Timeout">Deadline-Timeout</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <div className="adminUserorder-filter-container">
            {[
              "All",
              "Electrician",
              "Home Cleaning",
              "Plumber",
              "Gas Chula",
              "AC Service",
              "Filter",
              "Tutor Service",
            ].map((type) => (
              <Button
                key={type}
                variant={filterType === type ? "primary" : "outline-primary"}
                className="adminUserorder-filter-btn"
                onClick={() => {
                  setFilterType(type);
                  setCurrentPage(1); // reset page on filter change
                }}
              >
                {type}
              </Button>
            ))}
          </div>

          <Table
            striped
            bordered
            hover
            responsive
            className="adminUserorder-table"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Order number</th>
                <th>Order ID</th>
                <th>Mobile</th>
                <th>Service</th>
                <th>Status</th>
                <th>Price</th>
                <th>Date</th>
                <th>Time</th>
                <th>Deadline</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {orders.length === 0 ? (
                <tr>
                  <td colSpan={11} className="text-center text-muted">
                    No orders found.
                  </td>
                </tr>
              ) : (
                orders.map((order, index) => {
                  const statusLC = String(order.status || "").toLowerCase();
                  const editDisabled =
                    statusLC === "in-progress" || statusLC === "completed";
                  return (
                    <tr key={`${order.order_number}-${order.Id}`}>
                      <td>{index + 1 + indexOfFirstItem}</td>
                      <td>{order.order_number}</td>
                      <td>{order.Id}</td>
                      {/* <td>{order.User?.Id}</td> */}
                      <td>{order.User?.mobile}</td>
                      <td>{order.Service?.services_name}</td>
                      <td>
                        <Badge
                          className={`adminUserorder-badge-${order.status
                            .toLowerCase()
                            .replace(" ", "-")}`}
                        >
                          {order.status}
                        </Badge>
                      </td>
                      <td>{order.price}Tk</td>
                      <td>{formatDate(order.date)}</td>
                      <td>{formatTimeDisplay(order.time)}</td>
                      <td>{formatDeadlineTime(order.deadline)}</td>
                      <td>
                        <div className="adminUserorder-action-group">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="adminUserorder-action-btn"
                            onClick={() => handleViewDetails(order)}
                          >
                            <BsEye size={16} />
                          </Button>
                          <Button
                            variant="outline-edit"
                            size="sm"
                            className="adminUserorder-action-btn"
                            onClick={() => handleEditOrder(order)}
                            disabled={editDisabled}
                            title={
                              editDisabled
                                ? "Cannot edit when order is In-Progress or Completed"
                                : "Edit schedule"
                            }
                          >
                            <FaEdit size={16} />
                          </Button>
                          {/* <Button
                            variant="outline-danger"
                            size="sm"
                            className="adminUserorder-action-btn"
                            onClick={() => handleDeleteOrder(order)}
                          >
                            <FaTrash size={16} />
                          </Button> */}

                          {["pending", "Deadline-Timeout", "Accepted"].includes(
                            order.status
                          ) && (
                            <Button
                              variant="outline-success"
                              size="sm"
                              className="adminUserorder-action-btn"
                              onClick={() => openAssignModal(order)}
                              title="Assign a servitor to this order"
                            >
                              <FaCheckCircle size={16} />
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>

          {/* Pagination (server-driven) */}
          <Pagination>
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
            />

            {getPageItems(totalPages, currentPage).map((item, idx) => {
              if (item === "start-ellipsis" || item === "end-ellipsis") {
                return <Pagination.Ellipsis key={item + idx} disabled />;
              }
              return (
                <Pagination.Item
                  key={item}
                  active={item === currentPage}
                  onClick={() => handlePageChange(item)}
                >
                  {item}
                </Pagination.Item>
              );
            })}

            <Pagination.Next
              onClick={() =>
                handlePageChange(Math.min(totalPages, currentPage + 1))
              }
              disabled={currentPage === totalPages}
            />
            <Pagination.Last
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
            />
          </Pagination>
        </Card.Body>
      </Card>

      {showModal && (
        <div className="adminUserorder-modal-backdrop" ref={modalRef}>
          {renderOrderDetails()}
        </div>
      )}

      {showEdit && editOrder && (
        <div className="adminUserorder-modal-backdrop" ref={editModalRef}>
          <div className="adminUserorder-modal">
            {/* Header */}
            <div className="adminUserorder-modal-header">
              <button
                className="adminUserorder-modal-close"
                onClick={handleCloseEdit}
              >
                <FaTimes size={20} />
              </button>
              <div>
                <h2 className="adminUserorder-modal-title">Edit Schedule</h2>
                <p className="adminUserorder-modal-subtitle">
                  Order #{editOrder.order_number} •{" "}
                  {editOrder.Service?.services_name}
                </p>
              </div>
            </div>

            {/* Body */}
            <div className="adminUserorder-modal-body">
              {/* Date & Time (only) */}
              {(() => {
                const { slots, minDateISO, minTimeInfo } = slotData;
                return (
                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>New Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={editForm.newDate}
                          min={minDateISO}
                          onChange={(e) =>
                            setEditForm((f) => ({
                              ...f,
                              newDate: e.target.value,
                            }))
                          }
                        />
                        <div
                          className="adminUserorder-detail-text"
                          style={{ marginTop: 6 }}
                        >
                          Earliest allowed date: {minDateISO}
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>New Time</Form.Label>
                        <Form.Select
                          value={editForm.newSlot}
                          onChange={(e) =>
                            setEditForm((f) => ({
                              ...f,
                              newSlot: e.target.value,
                            }))
                          }
                          disabled={slots.length === 0}
                        >
                          {slots.length === 0 ? (
                            <option value="">
                              No available slots — pick another date
                            </option>
                          ) : (
                            slots.map((s) => (
                              <option key={s} value={s}>
                                {s}
                              </option>
                            ))
                          )}
                        </Form.Select>
                        {minTimeInfo && (
                          <div
                            className="adminUserorder-detail-text"
                            style={{ marginTop: 6 }}
                          >
                            {minTimeInfo}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                );
              })()}

              <Row className="mb-3">
                <Col md={12}>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      id="reorder"
                      label="Reorder (assign a new servitor)"
                      checked={editForm.reorder}
                      onChange={(e) =>
                        setEditForm((f) => ({
                          ...f,
                          reorder: e.target.checked,
                          // if reordering, must not keep current servitor
                          keepServitor: e.target.checked
                            ? false
                            : f.keepServitor,
                        }))
                      }
                    />
                    <div
                      className="adminUserorder-detail-text"
                      style={{ marginTop: 6 }}
                    >
                      This will reset the order to <b>Pending</b> and clear the
                      current servitor assignment, OTP/PIN and acceptance
                      timestamps.
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={12}>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      id="keep-servitor"
                      label={
                        editForm.reorder
                          ? "Keep current servitor (disabled because Reorder is selected)"
                          : forceKeepStatuses.includes(editOrder.status)
                          ? "Keep current servitor (required for this status)"
                          : "Keep current servitor (if already assigned)"
                      }
                      checked={
                        editForm.reorder
                          ? false
                          : forceKeepStatuses.includes(editOrder.status)
                          ? true
                          : editForm.keepServitor
                      }
                      onChange={(e) =>
                        setEditForm((f) => ({
                          ...f,
                          keepServitor: e.target.checked,
                        }))
                      }
                      disabled={
                        editForm.reorder ||
                        forceKeepStatuses.includes(editOrder.status)
                      }
                    />

                    <div
                      className="adminUserorder-detail-text"
                      style={{ marginTop: 6 }}
                    >
                      If unchecked (and order is not Accepted/In-Progress), any
                      servitor assignment may be cleared.
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Reason (optional)</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Add a short note for audit (e.g., user requested to move to tomorrow)."
                      value={editForm.reason}
                      onChange={(e) =>
                        setEditForm((f) => ({
                          ...f,
                          reason: e.target.value,
                        }))
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>

            {/* Footer */}
            <div className="adminUserorder-modal-footer">
              <div className="adminUserorder-footer-buttons">
                <button
                  className="adminUserorder-footer-btn adminUserorder-footer-btn-close"
                  onClick={submitEdit}
                  disabled={
                    saving ||
                    !editForm.newDate ||
                    !editForm.newSlot ||
                    slotData.slots.length === 0
                  }
                >
                  {saving ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <FaCheck />
                  )}
                  {saving ? " Updating..." : "Update"}
                </button>
                <button
                  className="adminUserorder-footer-btn adminUserorder-footer-btn-print"
                  onClick={handleCloseEdit}
                  disabled={saving}
                >
                  <FaTimes /> Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Assign servitor by admin */}

      {showAssign && assignOrder && (
        <div
          className="adminUserorder-modal-backdrop"
          onClick={(e) => e.target === e.currentTarget && closeAssignModal()}
        >
          <div className="adminUserorder-modal" role="dialog" aria-modal="true">
            <div className="adminUserorder-modal-header">
              <button
                className="adminUserorder-modal-close"
                onClick={closeAssignModal}
              >
                <FaTimes size={20} />
              </button>
              <div>
                <h2 className="adminUserorder-modal-title">Assign Servitor</h2>
                <p className="adminUserorder-modal-subtitle">
                  Order #{assignOrder.order_number} •{" "}
                  {assignOrder.Service?.services_name}
                </p>
              </div>
            </div>

            <div className="adminUserorder-modal-body">
              <Row className="mb-3">
                <Col md={12}>
                  <Form.Group>
                    {/* Searchable Mobile dropdown */}
                    <Row className="mb-3">
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label>
                            Servitor Mobile (search & select)
                          </Form.Label>
                          <Form.Control
                            list="servitorMobiles"
                            placeholder="Type to search by mobile / name / city — then pick the mobile"
                            value={servitorQuery}
                            onChange={(e) => {
                              const v = e.target.value;
                              setServitorQuery(v);
                              pickServitorByMobile(v);
                            }}
                          />
                          <datalist id="servitorMobiles">
                            {/* build rich label but the value must be the mobile for selection */}
                            {servitorList
                              .filter((r) => {
                                const q = servitorQuery.trim().toLowerCase();
                                if (!q) return true;
                                const hay = [
                                  r.mobile,
                                  r.FirstName,
                                  r.LastName,
                                  r.city,
                                  r.area,
                                  r.Address,
                                ]
                                  .filter(Boolean)
                                  .join(" ")
                                  .toLowerCase();
                                return hay.includes(q);
                              })
                              .slice(0, 50) // keep dropdown concise
                              .map((r) => (
                                <option
                                  key={r.Id}
                                  value={r.mobile}
                                  label={`${r.mobile} — ${r.FirstName || ""} ${
                                    r.LastName || ""
                                  } (${r.city || "-"} / ${r.area || "-"})`}
                                />
                              ))}
                          </datalist>
                          <div
                            className="adminUserorder-detail-text"
                            style={{ marginTop: 6 }}
                          >
                            Pick a mobile from the list. We’ll auto-fill the
                            servitor’s ID and show details below.
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    {/* Auto-filled details preview */}
                    {selectedServitor && (
                      <Row className="mb-3">
                        <Col md={12}>
                          <Card className="adminUserorder-servitor-card">
                            <div className="adminUserorder-servitor-header">
                              Selected Servitor
                            </div>

                            <div className="adminUserorder-servitor-grid">
                              <div className="adminUserorder-kv">
                                <div className="adminUserorder-kv-label">
                                  Name
                                </div>
                                <div className="adminUserorder-kv-value">
                                  {selectedServitor.FirstName}{" "}
                                  {selectedServitor.LastName}
                                </div>
                              </div>

                              <div className="adminUserorder-kv">
                                <div className="adminUserorder-kv-label">
                                  City / Area
                                </div>
                                <div className="adminUserorder-kv-value">
                                  {[
                                    selectedServitor.city,
                                    selectedServitor.area,
                                  ]
                                    .filter(Boolean)
                                    .join(" / ")}
                                </div>
                              </div>

                              <div className="adminUserorder-kv">
                                <div className="adminUserorder-kv-label">
                                  Mobile
                                </div>
                                <div className="adminUserorder-kv-value">
                                  {selectedServitor.mobile}
                                </div>
                              </div>

                              <div className="adminUserorder-kv">
                                <div className="adminUserorder-kv-label">
                                  Address
                                </div>
                                <div className="adminUserorder-kv-value">
                                  {selectedServitor.Address || "-"}
                                </div>
                              </div>

                              <div className="adminUserorder-kv">
                                <div className="adminUserorder-kv-label">
                                  ID
                                </div>
                                <div className="adminUserorder-kv-value">
                                  {selectedServitor.Id}
                                </div>
                              </div>

                              <div className="adminUserorder-kv">
                                <div className="adminUserorder-kv-label">
                                  Status / Availability
                                </div>
                                <div className="adminUserorder-kv-value">
                                  {selectedServitor.approve_status || "-"} /{" "}
                                  {selectedServitor.availability || "-"}
                                </div>
                              </div>
                            </div>
                          </Card>
                        </Col>
                      </Row>
                    )}

                    {/* (Optional) Keep manual ID as a fallback/advanced entry */}
                    <Row className="mb-3">
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label>Servitor ID (auto-filled)</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Auto-filled after you select a mobile; or override manually"
                            value={assignForm.servitorId}
                            readOnly
                            disabled
                            title="Auto-filled from servitor selection"
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <div
                      className="adminUserorder-detail-text"
                      style={{ marginTop: 6 }}
                    >
                      Tip: paste Servitor Id from the Servitors list, or add a
                      small search UI later.
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {assignOrder.Service?.services_name === "Tutor Service" && (
                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Check
                        type="checkbox"
                        id="markApproved"
                        label="Mark tutor as approved (I confirmed with the user over the phone)"
                        checked={assignForm.markApproved}
                        onChange={(e) =>
                          setAssignForm((f) => ({
                            ...f,
                            markApproved: e.target.checked,
                          }))
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}

              <Row className="mb-3">
                <Col md={12}>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      id="forceReassign"
                      label="Force reassign (clear existing servitor & acceptance timestamps)"
                      checked={assignForm.forceReassign}
                      onChange={(e) =>
                        setAssignForm((f) => ({
                          ...f,
                          forceReassign: e.target.checked,
                        }))
                      }
                    />
                    <div
                      className="adminUserorder-detail-text"
                      style={{ marginTop: 6 }}
                    >
                      Useful if another servitor was set but never started.
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </div>

            <div className="adminUserorder-modal-footer">
              <div className="adminUserorder-footer-buttons">
                <button
                  className="adminUserorder-footer-btn adminUserorder-footer-btn-close"
                  disabled={assigning || !assignForm.servitorId}
                  onClick={async () => {
                    try {
                      setAssigning(true);
                      const serviceType =
                        assignOrder.Service?.services_name || "";
                      const url = `${URL}/admin/orders/${encodeURIComponent(
                        serviceType
                      )}/${encodeURIComponent(
                        assignOrder.order_number
                      )}/assign`;

                      const payload = {
                        servitorId: Number(assignForm.servitorId),
                        markApproved: !!assignForm.markApproved,
                        forceReassign: !!assignForm.forceReassign,
                      };
                      const resp = await axios.post(url, payload, {
                        headers: getAdminHeaders(),
                      });
                      const pin = resp?.data?.order?.verification_pin;
                      alert(
                        `Servitor assigned successfully.${
                          pin
                            ? `\nPIN (share only with the servitor & user when needed): ${pin}`
                            : ""
                        }`
                      );
                      await fetchOrders();
                      closeAssignModal();
                    } catch (err) {
                      console.error("Assign servitor failed:", err);
                      const msg =
                        err?.response?.data?.message ||
                        err?.response?.data?.error ||
                        "Failed to assign servitor";
                      alert(msg);
                    } finally {
                      setAssigning(false);
                    }
                  }}
                >
                  {assigning ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <FaCheck />
                  )}
                  {assigning ? " Assigning..." : "Assign"}
                </button>

                <button
                  className="adminUserorder-footer-btn adminUserorder-footer-btn-print"
                  onClick={closeAssignModal}
                  disabled={assigning}
                >
                  <FaTimes /> Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {invoiceOrder && (
        <ReceiptGenerator
          order={invoiceOrder}
          onFinish={() => setInvoiceOrder(null)}
        />
      )}
    </Container>
  );
};

export default UserOrders;
